(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 7314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2223);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(2202);
;// CONCATENATED MODULE: ../../packages/ui/components/toast/showToast.tsx



// import { Icon } from "@billy/ui";

const SuccessToast = (param)=>/*#__PURE__*/ {
    let { message , toastVisible  } = param;
    return _jsxs("div", {
        className: classNames("data-testid-toast-success bg-brand-500 mb-2 flex h-9 items-center space-x-2 rounded-md p-3 text-sm font-semibold text-white shadow-md rtl:space-x-reverse", toastVisible && "animate-fade-in-up"),
        children: [
            /*#__PURE__*/ _jsx(FiCheck, {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: message
            })
        ]
    });
};
const ErrorToast = (param)=>/*#__PURE__*/ {
    let { message , toastVisible  } = param;
    return _jsxs("div", {
        className: classNames("animate-fade-in-up mb-2 flex h-9 items-center space-x-2 rounded-md bg-red-100 p-3 text-sm font-semibold text-red-900 shadow-md rtl:space-x-reverse", toastVisible && "animate-fade-in-up"),
        children: [
            /*#__PURE__*/ _jsx(FiInfo, {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: message
            })
        ]
    });
};
const WarningToast = (param)=>/*#__PURE__*/ {
    let { message , toastVisible  } = param;
    return _jsxs("div", {
        className: classNames("animate-fade-in-up bg-brand-500 mb-2 flex h-9 items-center space-x-2 rounded-md p-3 text-sm font-semibold text-white shadow-md rtl:space-x-reverse", toastVisible && "animate-fade-in-up"),
        children: [
            /*#__PURE__*/ _jsx(FiInfo, {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: message
            })
        ]
    });
};
const DefaultToast = (param)=>/*#__PURE__*/ {
    let { message , toastVisible  } = param;
    return _jsxs("div", {
        className: classNames("animate-fade-in-up bg-brand-500 mb-2 flex h-9 items-center space-x-2 rounded-md p-3 text-sm font-semibold text-white shadow-md rtl:space-x-reverse", toastVisible && "animate-fade-in-up"),
        children: [
            /*#__PURE__*/ _jsx(FiCheck, {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: message
            })
        ]
    });
};
const TOAST_VISIBLE_DURATION = 6000;
function showToast_showToast(message, variant) {
    let duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : TOAST_VISIBLE_DURATION;
    switch(variant){
        case "success":
            toast.custom((t)=>/*#__PURE__*/ _jsx(SuccessToast, {
                    message: message,
                    toastVisible: t.visible
                }), {
                duration
            });
            break;
        case "error":
            toast.custom((t)=>/*#__PURE__*/ _jsx(ErrorToast, {
                    message: message,
                    toastVisible: t.visible
                }), {
                duration
            });
            break;
        case "warning":
            toast.custom((t)=>/*#__PURE__*/ _jsx(WarningToast, {
                    message: message,
                    toastVisible: t.visible
                }), {
                duration
            });
            break;
        default:
            toast.custom((t)=>/*#__PURE__*/ _jsx(DefaultToast, {
                    message: message,
                    toastVisible: t.visible
                }), {
                duration
            });
            break;
    }
}

;// CONCATENATED MODULE: ../../packages/ui/components/toast/index.tsx


;// CONCATENATED MODULE: ../../packages/ui/components/alert/Alert.tsx




function Alert(props) {
    const { severity , iconClassName  } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("rounded-md border border-opacity-20 p-3", props.className, severity === "error" && "border-red-900 bg-red-50 text-red-800", severity === "warning" && "border-yellow-700 bg-yellow-50 text-yellow-700", severity === "info" && "border-sky-700 bg-sky-50 text-sky-700", severity === "success" && "bg-gray-900 text-white", severity === "neutral" && "border-none bg-gray-100"),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "relative flex flex-col md:flex-row",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex-shrink-0",
                    children: [
                        severity === "error" && /*#__PURE__*/ _jsx(XCircleIcon, {
                            className: classNames("h-5 w-5 text-red-400", iconClassName),
                            "aria-hidden": "true"
                        }),
                        severity === "warning" && /*#__PURE__*/ _jsx(ExclamationIcon, {
                            className: classNames("h-5 w-5 text-yellow-400", iconClassName),
                            "aria-hidden": "true"
                        }),
                        severity === "info" && /*#__PURE__*/ _jsx(InformationCircleIcon, {
                            className: classNames("h-5 w-5 text-sky-400", iconClassName),
                            "aria-hidden": "true"
                        }),
                        severity === "neutral" && /*#__PURE__*/ _jsx(FiInfo, {
                            className: classNames("h-5 w-5 text-gray-800", iconClassName),
                            "aria-hidden": "true"
                        }),
                        severity === "success" && /*#__PURE__*/ _jsx(CheckCircleIcon, {
                            className: classNames("h-5 w-5 text-gray-400", iconClassName),
                            "aria-hidden": "true"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "ml-3 flex-grow",
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            className: "text-sm font-medium",
                            children: props.title
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-sm",
                            children: props.message
                        })
                    ]
                }),
                props.actions && /*#__PURE__*/ _jsx("div", {
                    className: "absolute top-1 right-1 text-sm md:relative",
                    children: props.actions
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/alert/index.ts


// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ../../packages/ui/components/avatar/Avatar.tsx







const sizesPropsBySize = {
    xs: "w-4 h-4",
    sm: "w-6 h-6",
    md: "w-8 h-8",
    mdLg: "w-10 h-10",
    lg: "w-16 h-16",
    xl: "w-24 h-24"
};
function Avatar_Avatar(props) {
    const { imageSrc , gravatarFallbackMd5 , size , alt , title , href , initials  } = props;
    const rootClass = classNames("aspect-square rounded-full", sizesPropsBySize[size]);
    let avatar = /*#__PURE__*/ _jsx(AvatarPrimitive.Root, {
        className: classNames("dark:bg-darkgray-300 item-center relative inline-flex aspect-square justify-center overflow-hidden rounded-full border border-gray-100 bg-gray-100", props.className, sizesPropsBySize[size]),
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                !initials ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(AvatarPrimitive.Image, {
                            src: imageSrc !== null && imageSrc !== void 0 ? imageSrc : undefined,
                            alt: alt,
                            className: classNames("aspect-square rounded-full", sizesPropsBySize[size])
                        }),
                        /*#__PURE__*/ _jsx(AvatarPrimitive.Fallback, {
                            delayMs: 600,
                            asChild: props.asChild,
                            children: /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    props.fallback && !gravatarFallbackMd5 && props.fallback,
                                    gravatarFallbackMd5 && /*#__PURE__*/ _jsx("img", {
                                        src: defaultAvatarSrc({
                                            md5: gravatarFallbackMd5
                                        }),
                                        alt: alt,
                                        className: rootClass
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(AvatarPrimitive.Fallback, {
                    className: "text-violet11 leading-1 flex h-full w-full items-center justify-center bg-transparent text-[12px] font-medium",
                    children: initials
                }),
                props.accepted && /*#__PURE__*/ _jsx("div", {
                    className: classNames("absolute bottom-0 right-0 block rounded-full bg-green-400 text-white ring-2 ring-white", size === "lg" ? "h-5 w-5" : "h-2 w-2"),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "flex h-full items-center justify-center p-[2px]",
                        children: size === "lg" && /*#__PURE__*/ _jsx(FiCheck, {})
                    })
                })
            ]
        })
    });
    if (href) {
        avatar = /*#__PURE__*/ _jsx(Link, {
            href: href,
            children: avatar
        });
    }
    return title ? /*#__PURE__*/ _jsx(Tooltip.Provider, {
        children: /*#__PURE__*/ _jsxs(Tooltip.Tooltip, {
            delayDuration: 300,
            children: [
                /*#__PURE__*/ _jsx(Tooltip.TooltipTrigger, {
                    className: "cursor-default",
                    children: avatar
                }),
                /*#__PURE__*/ _jsxs(Tooltip.Content, {
                    className: "rounded-sm bg-black p-2 text-sm text-white shadow-sm",
                    children: [
                        /*#__PURE__*/ _jsx(Tooltip.Arrow, {}),
                        title
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ _jsx(_Fragment, {
        children: avatar
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/avatar/AvatarGroup.tsx



const AvatarGroup = function AvatarGroup(props) {
    const LENGTH = props.items.length;
    const truncateAfter = props.truncateAfter || 4;
    /**
   * First, filter all the avatars object that have image
   * Then, slice it until before `truncateAfter` index
   */ const displayedAvatars = props.items.filter((avatar)=>avatar.image).slice(0, truncateAfter);
    const numTruncatedAvatars = LENGTH - displayedAvatars.length;
    return /*#__PURE__*/ _jsxs("ul", {
        className: classNames("flex items-center", props.className),
        children: [
            displayedAvatars.map((item, idx)=>/*#__PURE__*/ _jsx("li", {
                    className: "-mr-[4px] inline-block",
                    children: /*#__PURE__*/ _jsx(Avatar, {
                        className: "border-gray-200",
                        imageSrc: item.image,
                        title: item.title,
                        alt: item.alt || "",
                        accepted: props.accepted,
                        size: props.size,
                        href: item.href
                    })
                }, idx)),
            numTruncatedAvatars > 0 && /*#__PURE__*/ _jsx("li", {
                className: classNames("bg-darkgray-300 relative -mr-[4px] mb-1 inline-flex justify-center overflow-hidden rounded-full", props.size === "sm" ? "min-w-6 h-6" : "min-w-16 h-16"),
                children: /*#__PURE__*/ _jsxs("span", {
                    className: classNames("m-auto px-1 text-center text-white", props.size === "sm" ? "text-[12px]" : "text-2xl"),
                    children: [
                        "+",
                        numTruncatedAvatars
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/components/avatar/index.ts



// EXTERNAL MODULE: ../../node_modules/class-variance-authority/dist/index.esm.js
var index_esm = __webpack_require__(4905);
;// CONCATENATED MODULE: ../../packages/ui/components/badge/Badge.tsx




const badgeStyles = (0,index_esm/* cva */.j)("font-medium inline-flex items-center justify-center rounded gap-x-1", {
    variants: {
        variant: {
            default: "bg-orange-100 text-orange-800",
            warning: "bg-orange-100 text-orange-800",
            orange: "bg-orange-100 text-orange-800",
            success: "bg-green-100 text-green-800",
            green: "bg-green-100 text-green-800",
            gray: "bg-gray-100 text-gray-800 dark:bg-darkgray-200 dark:text-darkgray-800 group-hover:bg-gray-200 dark:group-hover:bg-darkgray-300",
            blue: "bg-blue-100 text-blue-800",
            red: "bg-red-100 text-red-800",
            error: "bg-red-100 text-red-800"
        },
        size: {
            sm: "px-1 py-0.5 text-xs leading-3",
            md: "py-1 px-1.5 text-xs leading-3",
            lg: "py-1 px-2 text-sm leading-4"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "md"
    }
});
const Badge_Badge = function Badge(props) {
    const { variant , className , size , startIcon , withDot , children , rounded , ...passThroughProps } = props;
    const StartIcon = startIcon ? startIcon : undefined;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(badgeStyles({
            variant,
            size
        }), rounded && "h-5 w-5 rounded-full p-0", className),
        ...passThroughProps,
        children: [
            withDot ? /*#__PURE__*/ _jsx(GoPrimitiveDot, {
                className: "h-3 w-3 stroke-[3px]"
            }) : null,
            StartIcon ? /*#__PURE__*/ _jsx(StartIcon, {
                className: "h-3 w-3 stroke-[3px]"
            }) : null,
            /*#__PURE__*/ _jsx("div", {
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-tooltip/dist/index.module.js + 3 modules
var index_module = __webpack_require__(333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/lib/classNames.ts
function classNames_classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}

;// CONCATENATED MODULE: ../../packages/ui/components/tooltip/Tooltip.tsx




function Tooltip_Tooltip(param) {
    let { children , content , open , defaultOpen , onOpenChange , side ="top" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Root */.fC, {
        delayDuration: 50,
        open: open,
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Trigger */.xz, {
                asChild: true,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Portal */.h_, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Content */.VY, {
                    className: classNames_classNames(side === "top" && "-mt-7", side === "right" && "ml-2", "relative z-40 rounded-md bg-gray-900 px-2 py-1 text-xs font-semibold text-white shadow-lg dark:bg-white dark:text-gray-600 max-w-[300px]"),
                    side: side,
                    align: "center",
                    ...props,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "whitespace-pre-wrap",
                        children: content
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var tooltip_Tooltip = (Tooltip_Tooltip);

;// CONCATENATED MODULE: ../../packages/ui/components/tooltip/index.ts



;// CONCATENATED MODULE: ../../packages/ui/components/badge/UpgradeTeamsBadge.tsx


// import { useHasPaidPlan } from "@billy/lib/hooks/useHasPaidPlan";


const UpgradeTeamsBadge = function UpgradeTeamsBadge() {
    // const { hasPaidPlan } = useHasPaidPlan();
    // if (hasPaidPlan) return null;
    return /*#__PURE__*/ _jsx(Tooltip, {
        content: "upgrade_to_enable_feature",
        children: /*#__PURE__*/ _jsx(Link, {
            href: "/teams",
            children: /*#__PURE__*/ _jsx(Badge, {
                variant: "gray",
                children: "Upgrade"
            })
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/components/badge/index.ts



;// CONCATENATED MODULE: ../../packages/ui/components/custom-checkbox/CustomCheckboxSkeleton.tsx


function CustomCheckboxSkeleton() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "animate-pulse relative flex items-center px-4 py-4 sm:px-6 h-full w-full border border-neutral-200 rounded mb-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "inline-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "block h-6 w-6 mr-2 bg-gray-300 rounded"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "block w-[100px] h-2 bg-gray-300 rounded"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "block w-[100px] h-1 bg-gray-300 rounded"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex h-5 items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "inline-block h-4 w-4 rounded border border-gray-300"
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ../../packages/lib/currencies.ts
const EURO = "euro";
const USD = "usd";
const currencies = {
    [EURO]: {
        name: "euro",
        symbol: "€",
        iso: "EUR"
    },
    [USD]: {
        name: "usd",
        symbol: "$",
        iso: "USD"
    }
};
function getCurrencySymbol(name) {
    return currencies[name].symbol;
}
const allCurrenciesOptions = [
    {
        label: currencies[EURO].symbol,
        value: currencies[EURO].name
    },
    {
        label: currencies[USD].symbol,
        value: currencies[USD].name
    }
];
function formatPrice() {
    let price = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return decimals ? (Math.abs(price) / 100).toFixed(2) : Math.abs(price) / 100;
}

// EXTERNAL MODULE: ../../node_modules/superjson/dist/esm/index.js + 14 modules
var esm = __webpack_require__(5725);
// EXTERNAL MODULE: ../../node_modules/@trpc/react-query/dist/index.mjs + 37 modules
var react_query_dist = __webpack_require__(2658);
;// CONCATENATED MODULE: ../../packages/trpc/react/trpc.ts


/**
 * A set of strongly-typed React hooks from your `AppRouter` type signature with `createTRPCReact`.
 * @link https://trpc.io/docs/v10/react#2-create-trpc-hooks
 */ const trpc = (0,react_query_dist/* createTRPCReact */.ec)();
const transformer = (/* unused pure expression or super */ null && (superjson));

;// CONCATENATED MODULE: ../../packages/lib/hooks/useOrganization.ts


const useOrganization = (slug)=>{
    const { data: organization , isLoading  } = trpc.viewer.organizations.getBySlug.useQuery({
        slug
    }, {
        enabled: !!slug
    });
    if (isLoading) {
        return {
            isLoading
        };
    }
    if (!organization) {
        return {};
    }
    return {
        isLoading,
        name: organization === null || organization === void 0 ? void 0 : organization.name,
        slug: organization === null || organization === void 0 ? void 0 : organization.slug,
        currencySymbol: getCurrencySymbol(organization === null || organization === void 0 ? void 0 : organization.currency)
    };
};

// EXTERNAL MODULE: ../../node_modules/react-icons/fi/index.esm.js + 4 modules
var fi_index_esm = __webpack_require__(8596);
;// CONCATENATED MODULE: ../../packages/ui/components/custom-checkbox/CustomCheckbox.tsx








const paymentModels = {
    ONE_TIME: "ONE_TIME",
    RECURRING: "RECURRING"
};
const pricingModels = {
    STANDARD: "STANDARD",
    VOLUME: "VOLUME"
};
const billingPeriods = {
    MONTHLY: "MONTHLY",
    QUARTELY: "QUARTELY",
    SEMI_ANNUALLY: "SEMI_ANNUALLY",
    ANNUALLY: "ANNUALLY"
};
const formattedBillingPeriods = {
    MONTHLY: "month",
    QUARTELY: "every 3 months",
    SEMI_ANNUALLY: "every 6 months",
    ANNUALLY: "year"
};
const VolumeTooltip = (props)=>{
    const { tiers , currencySymbol  } = props;
    const TooltipContent = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "p-1 text-xs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-1",
                    children: "Volume pricing"
                }),
                tiers.map((tier, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "".concat(tier.firstUnit, " - ").concat(tier.lastUnit, " / ").concat(tier.unitAmount),
                            currencySymbol
                        ]
                    }, index))
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Provider */.zt, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_Tooltip, {
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContent, {}),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiInfo */.H33, {
                    className: "inline-block ml-1"
                })
            })
        })
    });
};
const CheckboxDescription = (props)=>{
    const { component , currencySymbol  } = props;
    const fBillignPeriod = formattedBillingPeriods[component === null || component === void 0 ? void 0 : component.billingPeriod] || "month";
    const lastIndicator = (component === null || component === void 0 ? void 0 : component.paymentModel) === paymentModels.RECURRING ? " / ".concat(fBillignPeriod) : null;
    if (component.pricingModel === pricingModels.VOLUME) {
        var ref, ref1;
        const unitPrice = component === null || component === void 0 ? void 0 : (ref = component.metadata) === null || ref === void 0 ? void 0 : ref.volumePricing.tiers[0].unitAmount;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                unitPrice,
                currencySymbol,
                " / ",
                component.name,
                lastIndicator,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeTooltip, {
                    tiers: component === null || component === void 0 ? void 0 : (ref1 = component.metadata) === null || ref1 === void 0 ? void 0 : ref1.volumePricing.tiers,
                    currencySymbol: currencySymbol
                })
            ]
        });
    }
    const ReccuringLabel = ()=>{
        return (component === null || component === void 0 ? void 0 : component.paymentModel) === paymentModels.RECURRING ? " / ".concat(fBillignPeriod) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                formatPrice(component === null || component === void 0 ? void 0 : component.price),
                " ",
                currencySymbol,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReccuringLabel, {})
            ]
        })
    });
};
const CustomCheckbox = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { label , description , error , disabled , prepend , append , classes , tooltip , component , organization , ...rest } = param;
    const { currencySymbol , isLoading  } = useOrganization(organization === null || organization === void 0 ? void 0 : organization.slug);
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCheckboxSkeleton, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative flex items-start",
        children: /*#__PURE__*/ react.createElement(label ? "label" : "div", {
            className: classNames_classNames("relative flex items-start select-none cursor-pointer hover:bg-gray-50", !error && label ? "text-gray-900" : "text-gray-900", error && "text-red-800", classes),
            ...!label ? {
                htmlFor: rest.id
            } : {}
        }, /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        tooltip ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Provider */.zt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_Tooltip, {
                                content: tooltip,
                                children: prepend && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: prepend
                                })
                            })
                        }) : prepend && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: prepend
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm",
                                    children: label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-xs text-gray-500",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxDescription, {
                                        component: component,
                                        currencySymbol: currencySymbol
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex h-5 items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            ...rest,
                            ref: ref,
                            type: "checkbox",
                            disabled: disabled,
                            className: classNames_classNames("text-primary-600 focus:ring-primary-500 h-4 w-4 rounded border-gray-300 ltr:mr-2 rtl:ml-2 ", !error && disabled ? "bg-gray-300 checked:bg-gray-300" : "checked:bg-gray-800 hover:bg-gray-100", error && "border-red-800 checked:bg-red-800 hover:bg-red-400")
                        }),
                        append
                    ]
                })
            ]
        }))
    });
});
CustomCheckbox.displayName = "CustomCheckbox";
/* harmony default export */ var custom_checkbox_CustomCheckbox = ((/* unused pure expression or super */ null && (CustomCheckbox)));

;// CONCATENATED MODULE: ../../packages/ui/components/custom-checkbox/index.ts


;// CONCATENATED MODULE: ../../packages/ui/components/layouts/AppLayout.tsx


function SideBar() {
    return /*#__PURE__*/ _jsx("aside", {
        className: "desktop-transparent hidden w-14 flex-col border-r border-gray-100 bg-gray-50 md:flex lg:w-56 lg:flex-shrink-0 lg:px-4",
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex h-0 flex-1 flex-col overflow-y-auto pt-3 pb-4 lg:pt-5",
            children: /*#__PURE__*/ _jsx("header", {
                className: "items-center justify-between md:hidden lg:flex",
                children: /*#__PURE__*/ _jsx(Link, {
                    className: "px-4",
                    href: "/event-types",
                    children: "billy"
                })
            })
        })
    });
}
const AppLayout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "h-screen overflow-hidden",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex h-screen overflow-hidden",
            children: [
                /*#__PURE__*/ _jsx(SideBar, {}),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex w-0 flex-1 flex-col overflow-hidden",
                    children: /*#__PURE__*/ _jsx("main", {
                        className: "relative z-0 flex flex-1 flex-col overflow-y-auto bg-white focus:outline-none",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "max-w-full px-4 py-2 lg:py-8 lg:px-12",
                            children: children
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var layouts_AppLayout = ((/* unused pure expression or super */ null && (AppLayout)));

;// CONCATENATED MODULE: ../../packages/ui/components/layouts/index.ts



;// CONCATENATED MODULE: ../../packages/lib/cva/cva.ts
/**
 * Lets you use arrays for variants as well. This util combines all possible
 * variants and returns an array with all possible options. Simply
 * spread this in the compoundVariants.
 */ const applyStyleToMultipleVariants = (variants)=>{
    const allKeysThatAreArrays = Object.keys(variants).filter((key)=>Array.isArray(variants[key]));
    const allKeysThatAreNotArrays = Object.keys(variants).filter((key)=>!Array.isArray(variants[key]));
    // Creates an object of all static options, ready to be merged in later with the array values.
    const nonArrayOptions = allKeysThatAreNotArrays.reduce((acc, key)=>{
        return {
            ...acc,
            [key]: variants[key]
        };
    }, {});
    // Creates an array of all possible combinations of the array values.
    // Eg if the variants object is { color: ["blue", "red"], size: ["small", "medium"] }
    // then the result will be:
    // [
    //   { color: "blue", size: "small" },
    //   { color: "blue", size: "medium" },
    //   { color: "red", size: "small" },
    //   { color: "red", size: "medium" },
    // ]
    const cartesianProductOfAllArrays = cartesianProduct(allKeysThatAreArrays.map((key)=>variants[key]));
    return cartesianProductOfAllArrays.map((variant)=>{
        const variantObject = variant.reduce((acc, value, index)=>{
            return {
                ...acc,
                [allKeysThatAreArrays[index]]: value
            };
        }, {});
        return {
            ...nonArrayOptions,
            ...variantObject
        };
    });
};
/**
 * A cartesian product is a final array that combines multiple arrays in ALL
 * variations possible. For example:
 *
 * You have 3 arrays: [a, b], [1, 2], [y, z]
 * The final result will be an array with all the different combinations:
 * ["a", 1, "y"], ["a", 1, "z"], ["a", 2, "y"], ["a", 2, "z"], ["b", 1, "y"], etc
 *
 * We use this to create a params object for the static pages that combine multiple
 * dynamic properties like 'stage' and 'meansOfTransport'. Resulting in an array
 * with all different path combinations possible.
 *
 * @source: https://stackoverflow.com/questions/12303989/cartesian-product-of-multiple-arrays-in-javascript
 * TS Inspiration: https://gist.github.com/ssippe/1f92625532eef28be6974f898efb23ef
 */ const cartesianProduct = (sets)=>sets.reduce((accSets, set)=>accSets.flatMap((accSet)=>set.map((value)=>[
                    ...accSet,
                    value
                ])), [
        []
    ]);

;// CONCATENATED MODULE: ../../packages/ui/components/button/Button.tsx







const buttonClasses = (0,index_esm/* cva */.j)("inline-flex items-center text-sm font-medium relative rounded-md transition-colors", {
    variants: {
        color: {
            primary: "text-white dark:text-black",
            secondary: "text-gray-900 dark:text-darkgray-900",
            minimal: "text-gray-900 dark:text-darkgray-900",
            destructive: ""
        },
        size: {
            sm: "px-3 py-2 leading-4 rounded-sm" /** For backwards compatibility */ ,
            base: "h-9 px-4 py-2.5 ",
            lg: "h-[36px] px-4 py-2.5 ",
            icon: "flex justify-center min-h-[36px] min-w-[36px] ",
            // fab = floating action button, used for the main action in a page.
            // it uses the same primary classNames for desktop size
            fab: "h-14 w-14 sm:h-9 sm:w-auto rounded-full justify-center sm:rounded-md sm:px-4 sm:py-2.5 radix-state-open:rotate-45 sm:radix-state-open:rotate-0 transition-transform radix-state-open:shadown-none radix-state-open:ring-0 !shadow-none"
        },
        loading: {
            true: "cursor-wait"
        },
        disabled: {
            true: "cursor-not-allowed"
        }
    },
    compoundVariants: [
        // Primary variants
        {
            disabled: true,
            color: "primary",
            className: "bg-gray-800 bg-opacity-30 dark:bg-opacity-30 dark:bg-darkgray-800"
        },
        {
            loading: true,
            color: "primary",
            className: "bg-gray-800/30 text-white/30 dark:bg-opacity-30 dark:bg-darkgray-700 dark:text-black/30"
        },
        ...applyStyleToMultipleVariants({
            disabled: [
                undefined,
                false
            ],
            color: "primary",
            className: "bg-brand-500 hover:bg-brand-400 focus:border focus:border-white focus:outline-none focus:ring-2 focus:ring-offset focus:ring-brand-500 dark:hover:bg-darkgray-600 dark:bg-darkgray-900"
        }),
        // Secondary variants
        {
            disabled: true,
            color: "secondary",
            className: "border border-gray-200 bg-opacity-30 text-gray-900/30 dark:text-darkgray-900/30 dark:border-darkgray-200"
        },
        {
            loading: true,
            color: "secondary",
            className: "bg-gray-100 text-gray-900/30 dark:bg-darkgray-100 dark:text-darkgray-900/30 dark:border-darkgray-200"
        },
        ...applyStyleToMultipleVariants({
            disabled: [
                undefined,
                false
            ],
            color: "secondary",
            className: "border border-gray-300 dark:border-darkgray-300 bg-white dark:bg-darkgray-100 hover:bg-gray-50 hover:border-gray-400 focus:bg-gray-100 dark:hover:bg-darkgray-200 dark:focus:bg-darkgray-200 focus:outline-none focus:ring-2 focus:ring-offset focus:ring-gray-900 dark:focus:ring-white"
        }),
        // Minimal variants
        {
            disabled: true,
            color: "minimal",
            className: "border:gray-200 bg-opacity-30 text-gray-900/30 dark:bg-darkgray-100 dark:text-darkgray-900/30 dark:border-darkgray-200"
        },
        {
            loading: true,
            color: "minimal",
            className: "bg-gray-100 text-gray-900/30 dark:bg-darkgray-100 dark:text-darkgray-900/30 dark:border-darkgray-200"
        },
        ...applyStyleToMultipleVariants({
            disabled: [
                undefined,
                false
            ],
            color: "minimal",
            className: "hover:bg-gray-100 focus:bg-gray-100 dark:hover:bg-darkgray-200 dark:focus:bg-darkgray-200 focus:outline-none focus:ring-2 focus:ring-offset focus:ring-gray-900 dark:focus:ring-white"
        }),
        // Destructive variants
        {
            disabled: true,
            color: "destructive",
            className: "text-red-700/30 dark:text-red-700/30 bg-red-100/40 dark:bg-red-100/80 border border-red-200"
        },
        {
            loading: true,
            color: "destructive",
            className: "text-red-700/30 dark:text-red-700/30 hover:text-red-700/30 bg-red-100 border border-red-200"
        },
        ...applyStyleToMultipleVariants({
            disabled: [
                false,
                undefined
            ],
            color: "destructive",
            className: "border dark:text-white text-gray-900 hover:text-red-700 focus:text-red-700 dark:hover:text-red-700 dark:focus:text-red-700 hover:border-red-100 focus:border-red-100 hover:bg-red-100  focus:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset focus:ring-red-700"
        })
    ],
    defaultVariants: {
        color: "primary",
        size: "base"
    }
});
const Button_Button = /*#__PURE__*/ (0,react.forwardRef)(function Button(props, forwardedRef) {
    const { loading =false , color ="primary" , size , type ="button" , StartIcon , EndIcon , shallow , // attributes propagated from `HTMLAnchorProps` or `HTMLButtonProps`
    ...passThroughProps } = props;
    // Buttons are **always** disabled if we're in a `loading` state
    const disabled = props.disabled || loading;
    // If pass an `href`-attr is passed it's `<a>`, otherwise it's a `<button />`
    const isLink = typeof props.href !== "undefined";
    const elementType = isLink ? "a" : "button";
    const element = /*#__PURE__*/ react.createElement(elementType, {
        ...passThroughProps,
        disabled,
        type: !isLink ? type : undefined,
        ref: forwardedRef,
        className: classNames_classNames(buttonClasses({
            color,
            size,
            loading,
            disabled: props.disabled
        }), props.className),
        // if we click a disabled button, we prevent going through the click handler
        onClick: disabled ? (e)=>{
            e.preventDefault();
        } : props.onClick
    }, /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            StartIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: size === "fab" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StartIcon, {
                        className: "hidden h-4 w-4 stroke-[1.5px] ltr:mr-2 sm:inline-flex"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StartIcon, {
                    className: classNames_classNames("inline-flex", size === "icon" ? "h-4 w-4 " : "h-4 w-4 stroke-[1.5px] mr-2")
                })
            }),
            size === "fab" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "hidden sm:inline",
                children: props.children
            }) : props.children,
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: "mx-4 h-5 w-5 animate-spin text-black dark:text-white",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            className: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            strokeWidth: "4"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            className: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                    ]
                })
            }),
            EndIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: size === "fab" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EndIcon, {
                        className: "-mr-1 hidden h-5 w-5 ltr:ml-2 rtl:-ml-1 rtl:mr-2 sm:inline"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EndIcon, {
                    className: "inline h-5 w-5 ltr:-mr-1 ltr:ml-2 rtl:mr-2"
                })
            })
        ]
    }));
    return props.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        passHref: true,
        href: props.href,
        shallow: shallow && shallow,
        legacyBehavior: true,
        children: element
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        tooltip: props.tooltip,
        children: element
    });
});
const Wrapper = (param)=>{
    let { children , tooltip  } = param;
    if (!tooltip) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_Tooltip, {
        content: tooltip,
        children: children
    });
};

;// CONCATENATED MODULE: ../../packages/ui/components/button/index.ts


;// CONCATENATED MODULE: ../../packages/ui/components/buttonGroup/ButtonGroup.tsx



/**
 * Breakdown of Tailwind Magic below
 * [&_button]:border-l-0 [&_a]:border-l-0 -> Selects all buttons/a tags and applies a border left of 0
 * [&>*:first-child]:rounded-l-md [&>*:first-child]:border-l -> Selects the first child of the content
 * ounds the left side
 * [&>*:last-child]:rounded-r-md -> Selects the last child of the content and rounds the right side
 * We dont need to add border to the right as we never remove it
 */ function ButtonGroup(param) {
    let { children , combined =false , containerProps  } = param;
    return /*#__PURE__*/ _jsx("div", {
        ...containerProps,
        className: classNames("flex", !combined ? "space-x-2 rtl:space-x-reverse" : "[&>*:first-child]:ml-0 [&>*:first-child]:rounded-l-md [&>*:first-child]:border-l [&>*:last-child]:rounded-r-md [&_button]:rounded-none [&_a]:rounded-none [&>a]:-ml-[1px] hover:[&>a]:z-[1] [&>button]:-ml-[1px] hover:[&>button]:z-[1]", containerProps === null || containerProps === void 0 ? void 0 : containerProps.className),
        children: children
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/buttonGroup/index.ts


// EXTERNAL MODULE: ../../node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(3848);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../../packages/ui/components/shell/Shell.tsx











const navigation = [
    {
        name: "Dashboard",
        href: "/dashboard",
        icon: fi_index_esm/* FiClipboard */.j4u
    },
    {
        name: "Submissions",
        href: "/submissions",
        icon: fi_index_esm/* FiArchive */.JYw
    },
    {
        name: "Pages",
        href: "/pages",
        icon: fi_index_esm/* FiFile */.tHe
    },
    {
        name: "Plans",
        href: "/plans",
        icon: fi_index_esm/* FiPackage */.zFh
    },
    {
        name: "Components",
        href: "/components",
        icon: fi_index_esm/* FiSliders */.NNy
    },
    {
        name: "Features",
        href: "/features",
        icon: fi_index_esm/* FiList */.SnF
    },
    {
        name: "Apps",
        href: "/apps",
        icon: fi_index_esm/* FiGrid */.aCJ
    },
    {
        name: "Settings",
        href: "/settings",
        icon: fi_index_esm/* FiSettings */.nbt
    }
];
const Navigation = ()=>{
    return /*#__PURE__*/ _jsx("nav", {
        className: "mt-2 flex-1 space-y-1 md:px-2 lg:mt-5 lg:px-0",
        children: navigation.map((item)=>/*#__PURE__*/ _jsx(NavigationItem, {
                item: item
            }, item.name))
    });
};
const footerNavigation = [
    {
        name: "Help",
        href: "https://help.billycpq.com",
        icon: fi_index_esm/* FiHelpCircle */.bax,
        target: "_blank"
    }
];
const FooterNavigation = ()=>{
    return /*#__PURE__*/ _jsx("nav", {
        className: "mt-2 flex-1 space-y-1 md:px-2 lg:mt-5 lg:px-0",
        children: footerNavigation.map((item)=>/*#__PURE__*/ _jsx(NavigationItem, {
                item: item
            }, item.name))
    });
};
const defaultIsCurrent = (param)=>{
    let { isChild , item , router  } = param;
    return isChild ? item.href === router.asPath : router.asPath.startsWith(item.href);
};
const NavigationItem = (props)=>{
    const { item , isChild  } = props;
    const router = useRouter();
    const isCurrent = item.isCurrent || defaultIsCurrent;
    const current = isCurrent({
        isChild: !!isChild,
        item,
        router
    });
    //const shouldDisplayNavigationItem = useShouldDisplayNavigationItem(props.item);
    //if (!shouldDisplayNavigationItem) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Link, {
                href: item.href,
                target: item.target,
                "aria-label": item.name,
                className: classNames("group flex items-center rounded-md py-2 px-3 text-sm font-medium text-gray-600 hover:bg-gray-100 lg:px-[14px]  [&[aria-current='page']]:bg-gray-200 [&[aria-current='page']]:hover:text-neutral-900", isChild ? "[&[aria-current='page']]:text-brand-900 hidden pl-16 lg:flex lg:pl-11 [&[aria-current='page']]:bg-transparent" : "[&[aria-current='page']]:text-brand-900 "),
                "aria-current": current ? "page" : undefined,
                children: [
                    item.icon && /*#__PURE__*/ _jsx(item.icon, {
                        className: "h-4 w-4 flex-shrink-0 text-gray-500 mr-3 [&[aria-current='page']]:text-inherit",
                        "aria-hidden": "true",
                        "aria-current": current ? "page" : undefined
                    }),
                    item.name ? /*#__PURE__*/ _jsxs("span", {
                        className: "hidden w-full justify-between lg:flex",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex",
                                children: item.name
                            }),
                            item.badge && item.badge
                        ]
                    }) : /*#__PURE__*/ _jsx(_Fragment, {})
                ]
            }),
            item.child && isCurrent({
                router,
                isChild,
                item
            }) && item.child.map((item)=>/*#__PURE__*/ _jsx(NavigationItem, {
                    item: item,
                    isChild: true
                }, item.name))
        ]
    });
};
const Shell_SideBar = ()=>{
    var ref, ref1;
    const { data: session  } = useSession();
    return /*#__PURE__*/ _jsxs("aside", {
        className: "desktop-transparent hidden w-14 flex-col border-r border-gray-100 bg-gray-50 md:flex lg:w-56 lg:flex-shrink-0 lg:px-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex h-0 flex-1 flex-col overflow-y-auto pt-3 pb-4 lg:pt-5",
                children: [
                    /*#__PURE__*/ _jsx("header", {
                        className: "items-center justify-between md:hidden lg:flex",
                        children: /*#__PURE__*/ _jsx(Link, {
                            className: "px-4",
                            href: "/",
                            children: /*#__PURE__*/ _jsx(Logo, {})
                        })
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "desktop-only absolute -left-3 -right-3 mt-4 block w-full border-gray-200"
                    }),
                    (session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.currentOrganization) ? /*#__PURE__*/ _jsx("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ _jsx(OrganizationSwitcher, {})
                    }) : null,
                    (session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.currentOrganization) ? /*#__PURE__*/ _jsx(Navigation, {}) : null
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(FooterNavigation, {}),
                    /*#__PURE__*/ _jsx(Button, {
                        color: "minimal",
                        className: "w-full mt-2",
                        StartIcon: (props)=>/*#__PURE__*/ _jsx(FiLogOut, {
                                className: "h-4 w-4 flex-shrink-0 text-gray-500 mr-3 [&[aria-current='page']]:text-inherit",
                                "aria-hidden": "true"
                            }),
                        onClick: ()=>signOut({
                                callbackUrl: "/auth/logout"
                            }),
                        children: "Sign out"
                    }),
                    /*#__PURE__*/ _jsxs("small", {
                        className: "mx-3 mt-1 mb-2 hidden text-[0.5rem] opacity-50 lg:block",
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " ",
                            /*#__PURE__*/ _jsx(Link, {
                                href: "/",
                                className: "hover:underline",
                                children: "billycpq"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function useRedirectToLoginIfUnauthenticated() {
    let isPublic = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const { data: session , status  } = useSession();
    const loading = status === "loading";
    const router = useRouter();
    useEffect(()=>{
        if (isPublic) {
            return;
        }
        if (!loading && !session) {
            router.replace({
                pathname: "/auth/login",
                query: {
                    callbackUrl: "".concat(WEBAPP_URL).concat(location.pathname).concat(location.search)
                }
            });
        }
    // TO:DO need to be refactored
    // if (session && !session.user?.currentOrganization){
    //   router.push('/dashboard');
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        session,
        isPublic
    ]);
    return {
        loading: loading && !session,
        session
    };
}
const MainContainer = (props)=>{
    const { bg , classes  } = props;
    const router = useRouter();
    const { session , loading  } = useRedirectToLoginIfUnauthenticated(props.isPublic);
    if (!session && !props.isPublic) {
        return null;
    }
    if (loading) {
        return /*#__PURE__*/ _jsx("div", {
            children: "loading"
        });
    }
    return /*#__PURE__*/ _jsx("main", {
        className: classNames("relative z-0 flex flex-1 flex-col overflow-y-auto focus:outline-none", bg ? bg : "bg-white", classes),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "max-w-full px-4 py-2 lg:py-8 lg:px-12",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-baseline sm:mt-0",
                    children: [
                        !!props.backPath && /*#__PURE__*/ _jsx(Button, {
                            size: "icon",
                            color: "minimal",
                            onClick: ()=>typeof props.backPath === "string" ? router.push(props.backPath) : router.back(),
                            StartIcon: FiArrowLeft,
                            "aria-label": "Go Back",
                            className: "mr-2"
                        }),
                        props.heading && /*#__PURE__*/ _jsxs("header", {
                            className: classNames("mb-4 flex w-full max-w-full items-center pt-4 md:p-0 lg:mb-10"),
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "w-full ltr:mr-4 rtl:ml-4 sm:block",
                                    children: [
                                        props.heading && /*#__PURE__*/ _jsx("h1", {
                                            className: "font-cal max-w-28 sm:max-w-72 md:max-w-80 mb-1 hidden truncate text-xl font-bold tracking-wide text-black sm:block xl:max-w-full",
                                            children: props.heading
                                        }),
                                        props.subtitle && /*#__PURE__*/ _jsx("p", {
                                            className: "hidden text-sm text-neutral-500 sm:block",
                                            children: props.subtitle
                                        })
                                    ]
                                }),
                                props.CTA && /*#__PURE__*/ _jsx("div", {
                                    className: classNames(props.backPath ? "relative" : "fixed right-4 bottom-[75px] z-40 ", "flex-shrink-0 sm:relative sm:bottom-auto sm:right-auto"),
                                    children: props.CTA
                                })
                            ]
                        })
                    ]
                }),
                props.children
            ]
        })
    });
};
const Layout = (props)=>{
    const { simpleLayout  } = props;
    return /*#__PURE__*/ _jsxs("div", {
        className: "h-screen overflow-hidden",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex h-screen overflow-hidden",
                children: simpleLayout ? /*#__PURE__*/ _jsx(MainContainer, {
                    ...props
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Shell_SideBar, {}),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex w-0 flex-1 flex-col overflow-hidden",
                            children: /*#__PURE__*/ _jsx(MainContainer, {
                                ...props
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Toaster, {
                position: "bottom-right"
            })
        ]
    });
};
function Shell(props) {
    return /*#__PURE__*/ _jsx(Layout, {
        ...props
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/shell/index.ts



;// CONCATENATED MODULE: ../../packages/ui/components/public-shell/PublicShell.tsx









const PublicShell_navigation = [
    {
        name: "Pages",
        href: "/pages",
        icon: fi_index_esm/* FiFile */.tHe
    },
    {
        name: "Plans",
        href: "/plans",
        icon: fi_index_esm/* FiPackage */.zFh
    },
    {
        name: "Components",
        href: "/components",
        icon: fi_index_esm/* FiSliders */.NNy
    },
    {
        name: "Features",
        href: "/features",
        icon: fi_index_esm/* FiList */.SnF
    },
    {
        name: "Apps",
        href: "/apps",
        icon: fi_index_esm/* FiGrid */.aCJ
    },
    {
        name: "Settings",
        href: "/settings",
        icon: fi_index_esm/* FiSettings */.nbt
    }
];
const PublicShell_Navigation = ()=>{
    return /*#__PURE__*/ _jsx("nav", {
        className: "mt-2 flex-1 space-y-1 md:px-2 lg:mt-5 lg:px-0",
        children: PublicShell_navigation.map((item)=>/*#__PURE__*/ _jsx(PublicShell_NavigationItem, {
                item: item
            }, item.name))
    });
};
const PublicShell_footerNavigation = [
    {
        name: "Organizations",
        href: "/organizations",
        icon: fi_index_esm/* FiUsers */.WY8
    }
];
const PublicShell_FooterNavigation = ()=>{
    return /*#__PURE__*/ _jsx("nav", {
        className: "mt-2 flex-1 space-y-1 md:px-2 lg:mt-5 lg:px-0",
        children: PublicShell_footerNavigation.map((item)=>/*#__PURE__*/ _jsx(PublicShell_NavigationItem, {
                item: item
            }, item.name))
    });
};
const PublicShell_defaultIsCurrent = (param)=>{
    let { isChild , item , router  } = param;
    return isChild ? item.href === router.asPath : router.asPath.startsWith(item.href);
};
const PublicShell_NavigationItem = (props)=>{
    const { item , isChild  } = props;
    const router = useRouter();
    const isCurrent = item.isCurrent || PublicShell_defaultIsCurrent;
    const current = isCurrent({
        isChild: !!isChild,
        item,
        router
    });
    //const shouldDisplayNavigationItem = useShouldDisplayNavigationItem(props.item);
    //if (!shouldDisplayNavigationItem) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Link, {
                href: item.href,
                "aria-label": item.name,
                className: classNames("group flex items-center rounded-md py-2 px-3 text-sm font-medium text-gray-600 hover:bg-gray-100 lg:px-[14px]  [&[aria-current='page']]:bg-gray-200 [&[aria-current='page']]:hover:text-neutral-900", isChild ? "[&[aria-current='page']]:text-brand-900 hidden pl-16 lg:flex lg:pl-11 [&[aria-current='page']]:bg-transparent" : "[&[aria-current='page']]:text-brand-900 "),
                "aria-current": current ? "page" : undefined,
                children: [
                    item.icon && /*#__PURE__*/ _jsx(item.icon, {
                        className: "h-4 w-4 flex-shrink-0 text-gray-500 mr-3 [&[aria-current='page']]:text-inherit",
                        "aria-hidden": "true",
                        "aria-current": current ? "page" : undefined
                    }),
                    item.name ? /*#__PURE__*/ _jsxs("span", {
                        className: "hidden w-full justify-between lg:flex",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex",
                                children: item.name
                            }),
                            item.badge && item.badge
                        ]
                    }) : /*#__PURE__*/ _jsx(_Fragment, {})
                ]
            }),
            item.child && isCurrent({
                router,
                isChild,
                item
            }) && item.child.map((item)=>/*#__PURE__*/ _jsx(PublicShell_NavigationItem, {
                    item: item,
                    isChild: true
                }, item.name))
        ]
    });
};
const PublicShell_SideBar = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx("aside", {
        className: "desktop-transparent hidden w-14 flex-col md:flex lg:w-[360px] lg:flex-shrink-0 lg:px-4",
        children: /*#__PURE__*/ _jsx("div", {
            className: "sticky top-[20px] mt-[40px]",
            children: children
        })
    });
};
function PublicShell_useRedirectToLoginIfUnauthenticated() {
    let isPublic = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const { data: session , status  } = useSession();
    const loading = status === "loading";
    const router = useRouter();
    useEffect(()=>{
        if (isPublic) {
            return;
        }
        if (!loading && !session) {
            router.replace({
                pathname: "/auth/login",
                query: {
                    callbackUrl: "".concat(WEBAPP_URL).concat(location.pathname).concat(location.search)
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        session,
        isPublic
    ]);
    return {
        loading: loading && !session,
        session
    };
}
const PublicShell_MainContainer = (props)=>{
    const { bg , classes  } = props;
    const router = useRouter();
    const { session , loading  } = PublicShell_useRedirectToLoginIfUnauthenticated(props.isPublic);
    if (!session && !props.isPublic) {
        return null;
    }
    if (loading) {
        return /*#__PURE__*/ _jsx("div", {
            children: "loading"
        });
    }
    return /*#__PURE__*/ _jsx("main", {
        className: classNames("relative z-0 flex flex-1 flex-col overflow-y-auto focus:outline-none", bg ? bg : "bg-white", classes),
        children: /*#__PURE__*/ _jsx("div", {
            className: "max-w-full px-4 py-4",
            children: props.children
        })
    });
};
const Header = (props)=>{
    const { organization  } = props;
    return /*#__PURE__*/ _jsxs("header", {
        className: "flex bg-gray-50 px-4 py-4",
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: organization === null || organization === void 0 ? void 0 : organization.name
            }),
            /*#__PURE__*/ _jsx("div", {})
        ]
    });
};
const Footer = (props)=>{
    return /*#__PURE__*/ _jsxs("small", {
        className: "mx-3 mt-1 mb-2 hidden text-[0.5rem] opacity-50 lg:block",
        children: [
            "\xa9 ",
            new Date().getFullYear(),
            " ",
            /*#__PURE__*/ _jsx(Link, {
                href: "/",
                className: "hover:underline",
                children: "BillyApp"
            })
        ]
    });
};
const PublicShell_Layout = (props)=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mx-auto max-w-[1200px]",
                children: [
                    /*#__PURE__*/ _jsx(Header, {
                        ...props
                    }),
                    /*#__PURE__*/ _jsx(PublicShell_MainContainer, {
                        ...props
                    }),
                    /*#__PURE__*/ _jsx(Footer, {
                        ...props
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Toaster, {
                position: "bottom-right"
            })
        ]
    });
};
function PublicShell(props) {
    return /*#__PURE__*/ _jsx(PublicShell_Layout, {
        ...props
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/public-shell/index.ts



;// CONCATENATED MODULE: ../../packages/ui/components/skeleton/Loader.tsx
/**
 * @deprecated Use custom Skeletons instead
 **/ 
function Loader() {
    return /*#__PURE__*/ _jsx("div", {
        className: "loader border-brand dark:border-darkmodebrand",
        children: /*#__PURE__*/ _jsx("span", {
            className: "loader-inner bg-brand dark:bg-darkmodebrand"
        })
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/skeleton/index.tsx



const SkeletonAvatar = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("mt-1 rounded-full bg-gray-200 ltr:mr-2 rtl:ml-2", className)
    });
};
const skeleton_Skeleton = (param)=>{
    let { as , className ="" , children , loading =false , /**
   * Assumes that the text needs translation by default and wait for it.
   */ waitForTranslation =true , /**
   * Classes that you need only in loading state
   */ loadingClassName ="" , ...rest } = param;
    // const { isLocaleReady } = useLocale();
    // loading = (waitForTranslation ? !isLocaleReady : false) || loading;
    const Component = as;
    return /*#__PURE__*/ _jsx(Component, {
        className: classNames(loading ? classNames("font-size-0 dark:white-300 animate-pulse rounded-md bg-gray-300 text-transparent", loadingClassName) : "", className),
        ...rest,
        children: children
    });
};
const skeleton_SkeletonText = (param)=>{
    let { className ="" , invisible =false  } = param;
    return /*#__PURE__*/ _jsx("span", {
        className: classNames("font-size-0 dark:white-300 inline-block animate-pulse rounded-md bg-gray-300 empty:before:inline-block empty:before:content-['']", className, invisible ? "invisible" : "")
    });
};
const SkeletonButton = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ _jsx(SkeletonContainer, {
        children: /*#__PURE__*/ _jsx("div", {
            className: classNames("rounded-md bg-gray-200", className)
        })
    });
};
const SkeletonContainer = (param)=>{
    let { children , as , className  } = param;
    const Component = as || "div";
    return /*#__PURE__*/ _jsx(Component, {
        className: classNames("animate-pulse", className),
        children: children
    });
};



;// CONCATENATED MODULE: ../../packages/ui/components/empty-screen/EmptyScreen.tsx



function EmptyScreen(param) {
    let { Icon , avatar , headline , description , buttonText , buttonOnClick , buttonRaw  } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            "data-testid": "empty-screen",
            className: "min-h-80 flex w-full flex-col items-center justify-center rounded-md border border-dashed p-7 lg:p-20",
            children: [
                !avatar ? null : /*#__PURE__*/ _jsx("div", {
                    className: "flex h-[72px] w-[72px] items-center justify-center rounded-full",
                    children: avatar
                }),
                !Icon ? null : /*#__PURE__*/ _jsx("div", {
                    className: "flex h-[72px] w-[72px] items-center justify-center rounded-full bg-gray-200 dark:bg-white",
                    children: /*#__PURE__*/ _jsx(Icon, {
                        className: "inline-block h-10 w-10 stroke-[1.3px] dark:bg-gray-900 dark:text-gray-600"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex max-w-[420px] flex-col items-center",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "text-semibold font-cal mt-6 text-center text-xl dark:text-gray-300",
                            children: headline
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mt-3 mb-8 text-center text-sm font-normal leading-6 text-gray-700 dark:text-gray-300",
                            children: description
                        }),
                        buttonOnClick && buttonText && /*#__PURE__*/ _jsx(Button, {
                            onClick: (e)=>buttonOnClick(e),
                            children: buttonText
                        }),
                        buttonRaw
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/empty-screen/index.ts


;// CONCATENATED MODULE: ../../packages/ui/components/list/List.tsx




function List(props) {
    return /*#__PURE__*/ _jsx("ul", {
        ...props,
        className: classNames("-mx-4 rounded-sm sm:mx-0 sm:overflow-hidden ", // Add rounded top and bottome if roundContainer is true
        props.roundContainer && "[&>*:first-child]:rounded-t-md [&>*:last-child]:rounded-b-md ", !props.noBorderTreatment && "divide-y divide-gray-200 rounded-md border border-l border-r ", props.className),
        children: props.children
    });
}
function ListItem(props) {
    const { href , expanded , rounded =true , ...passThroughProps } = props;
    const elementType = href ? "a" : "li";
    const element = /*#__PURE__*/ createElement(elementType, {
        ...passThroughProps,
        className: classNames("items-center bg-white min-w-0 flex-1 flex border-neutral-200 p-4 sm:mx-0 md:border md:p-4 xl:mt-0", expanded ? "my-2 border" : "border -mb-px last:mb-0", // Pass rounded false to not round the corners -> Usefull when used in list we can use roundedContainer to create the right design
        rounded ? "rounded-md" : "rounded-none", props.className, (props.onClick || href) && "hover:bg-neutral-50")
    }, props.children);
    return href ? /*#__PURE__*/ _jsx(Link, {
        passHref: true,
        href: href,
        legacyBehavior: true,
        children: element
    }) : element;
}
function ListLinkItem(props) {
    const { href , heading ="" , children , disabled =false , actions =/*#__PURE__*/ _jsx("div", {}) , className =""  } = props;
    let subHeading = props.subHeading;
    if (!subHeading) {
        subHeading = "";
    }
    return /*#__PURE__*/ _jsxs("li", {
        className: classNames("group flex w-full items-center justify-between p-5 hover:bg-neutral-50", className, disabled ? "hover:bg-white" : ""),
        children: [
            /*#__PURE__*/ _jsxs(Link, {
                passHref: true,
                href: href,
                className: classNames("flex-grow truncate text-sm", disabled ? "pointer-events-none cursor-not-allowed opacity-30" : ""),
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        className: "text-sm font-semibold leading-none",
                        children: heading
                    }),
                    /*#__PURE__*/ _jsxs("h2", {
                        className: "min-h-4 mt-2 text-sm font-normal leading-none",
                        children: [
                            subHeading.substring(0, 100),
                            subHeading.length > 100 && "..."
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-2",
                        children: children
                    })
                ]
            }),
            actions
        ]
    });
}
function ListItemTitle(props) {
    const { component ="span" , ...passThroughProps } = props;
    return /*#__PURE__*/ createElement(component, {
        ...passThroughProps,
        className: classNames("text-sm font-medium text-gray-900 truncate", props.className)
    }, props.children);
}
function ListItemText(props) {
    const { component ="span" , ...passThroughProps } = props;
    return /*#__PURE__*/ createElement(component, {
        ...passThroughProps,
        className: classNames("text-sm text-gray-500 truncate", props.className)
    }, props.children);
}

;// CONCATENATED MODULE: ../../packages/ui/components/list/index.ts


;// CONCATENATED MODULE: ../../packages/ui/components/layout/ShellSubHeading.tsx


function ShellSubHeading_ShellSubHeading(props) {
    return /*#__PURE__*/ _jsxs("header", {
        className: classNames("mb-3 block justify-between sm:flex", props.className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "flex content-center items-center space-x-2 text-base font-bold leading-6 text-gray-900 rtl:space-x-reverse",
                        children: props.title
                    }),
                    props.subtitle && /*#__PURE__*/ _jsx("p", {
                        className: "text-sm text-gray-500 ltr:mr-4",
                        children: props.subtitle
                    })
                ]
            }),
            props.actions && /*#__PURE__*/ _jsx("div", {
                className: "mt-2 flex-shrink-0 sm:mt-0",
                children: props.actions
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/layout/index.ts


// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../packages/ui/components/meta/Meta.tsx




const initialMeta = {
    title: "",
    description: "",
    backButton: false,
    CTA: null
};
const MetaContext = /*#__PURE__*/ (0,react.createContext)({
    meta: initialMeta,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setMeta: (newMeta)=>{}
});
function useMeta() {
    return useContext(MetaContext);
}
function MetaProvider(param) {
    let { children  } = param;
    const [value, setValue] = useState(initialMeta);
    const setMeta = (newMeta)=>{
        setValue((v)=>({
                ...v,
                ...newMeta
            }));
    };
    return /*#__PURE__*/ _jsx(MetaContext.Provider, {
        value: {
            meta: value,
            setMeta
        },
        children: children
    });
}
/**
 * The purpose of this component is to simplify title and description handling.
 * Similarly to `next/head`'s `Head` component this allow us to update the metadata for a page
 * from any children, also exposes the metadata via the `useMeta` hook in case we need them
 * elsewhere (ie. on a Heading, Title, Subtitle, etc.)
 * @example <Meta title="Password" description="Manage settings for your account passwords" />
 */ function Meta_Meta(param) {
    let { title , description , backButton , CTA  } = param;
    const { setMeta , meta  } = useMeta();
    /* @TODO: maybe find a way to have this data on first render to prevent flicker */ useEffect(()=>{
        if (meta.title !== title || meta.description !== description || meta.CTA !== CTA) {
            setMeta({
                title,
                description,
                backButton,
                CTA
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        title,
        description,
        backButton,
        CTA
    ]);
    const title_ = "".concat(title, " | ").concat(APP_NAME);
    return /*#__PURE__*/ _jsxs(Head, {
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: title_
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "description",
                content: description
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/apps/SkeletonLoader.tsx




function SkeletonLoader(param) {
    let { className , title , description  } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ShellSubHeading, {
                title: /*#__PURE__*/ _jsx("div", {
                    className: "h-6 w-32 bg-gray-100"
                }),
                className
            }),
            title && description && /*#__PURE__*/ _jsx(Meta, {
                title: title,
                description: description
            }),
            /*#__PURE__*/ _jsxs("ul", {
                className: "-mx-4 animate-pulse divide-y divide-neutral-200 rounded-md border border-gray-200 bg-white sm:mx-0 sm:overflow-hidden",
                children: [
                    /*#__PURE__*/ _jsx(SkeletonItem, {}),
                    /*#__PURE__*/ _jsx(SkeletonItem, {}),
                    /*#__PURE__*/ _jsx(SkeletonItem, {})
                ]
            })
        ]
    });
}
function SkeletonItem() {
    return /*#__PURE__*/ _jsxs("li", {
        className: "group flex w-full items-center justify-between p-3",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex-grow truncate text-sm",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex justify-start space-x-2 rtl:space-x-reverse",
                    children: [
                        /*#__PURE__*/ _jsx(SkeletonText, {
                            className: "h-10 w-10"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ _jsx(SkeletonText, {
                                    className: "h-4 w-32"
                                }),
                                /*#__PURE__*/ _jsx(SkeletonText, {
                                    className: "h-4 w-16"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-4 hidden flex-shrink-0 sm:mt-0 sm:ml-5 lg:flex",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex justify-between space-x-2 rtl:space-x-reverse",
                    children: /*#__PURE__*/ _jsx(SkeletonText, {
                        className: "h-11 w-32"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/apps/AppCard.tsx








function AppCard(param) {
    let { app , credentials , searchText  } = param;
    var ref, ref1;
    const router = useRouter();
    const mutation = useAddAppMutation(null, {
        onSuccess: (data)=>{
            // Refresh SSR page content without actual reload
            router.replace(router.asPath);
            if (data === null || data === void 0 ? void 0 : data.setupPending) return;
            showToast("app_successfully_installed", "success");
        },
        onError: (error)=>{
            if (error instanceof Error) showToast(error.message || "app_could_not_be_installed", "error");
        }
    });
    const allowedMultipleInstalls = app.categories && app.categories.indexOf("calendar") > -1;
    const appAdded = credentials && credentials.length || 0;
    const [searchTextIndex, setSearchTextIndex] = useState(undefined);
    useEffect(()=>{
        setSearchTextIndex(searchText ? app.name.toLowerCase().indexOf(searchText.toLowerCase()) : undefined);
    }, [
        app.name,
        searchText
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative flex h-64 flex-col rounded-md border border-gray-200 p-5",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex",
                children: /*#__PURE__*/ _jsx("img", {
                    src: app.logo,
                    alt: app.name + " Logo",
                    className: "mb-4 h-12 w-12 rounded-sm"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ _jsx("h3", {
                    className: "font-medium",
                    children: searchTextIndex != undefined && searchText ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            app.name.substring(0, searchTextIndex),
                            /*#__PURE__*/ _jsx("span", {
                                className: "bg-yellow-300",
                                children: app.name.substring(searchTextIndex, searchTextIndex + searchText.length)
                            }),
                            app.name.substring(searchTextIndex + searchText.length)
                        ]
                    }) : app.name
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-2 flex-grow text-sm text-gray-500",
                style: {
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: "3"
                },
                children: app.description
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-5 flex max-w-full flex-row justify-between gap-2",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        color: "secondary",
                        className: "flex w-32 flex-grow justify-center",
                        href: "/apps/".concat(app.slug),
                        "data-testid": "app-store-app-card-".concat(app.slug),
                        children: "Details"
                    }),
                    app.isGlobal || credentials && credentials.length > 0 && allowedMultipleInstalls ? !app.isGlobal && /*#__PURE__*/ _jsx(InstallAppButton, {
                        type: app.type,
                        isProOnly: app.isProOnly,
                        disableInstall: !!app.dependencies && !((ref = app.dependencyData) === null || ref === void 0 ? void 0 : ref.some((data)=>!data.installed)),
                        wrapperClassName: "[@media(max-width:260px)]:w-full",
                        render: (param)=>{
                            let { useDefaultComponent , ...props } = param;
                            if (useDefaultComponent) {
                                props = {
                                    ...props,
                                    onClick: ()=>{
                                        mutation.mutate({
                                            type: app.type,
                                            variant: app.variant,
                                            slug: app.slug
                                        });
                                    }
                                };
                            }
                            return /*#__PURE__*/ _jsx(Button, {
                                color: "secondary",
                                className: "[@media(max-width:260px)]:w-full [@media(max-width:260px)]:justify-center",
                                StartIcon: FiPlus,
                                ...props,
                                children: t("install")
                            });
                        }
                    }) : credentials && credentials.length === 0 && /*#__PURE__*/ _jsx(InstallAppButton, {
                        type: app.type,
                        isProOnly: app.isProOnly,
                        wrapperClassName: "[@media(max-width:260px)]:w-full",
                        disableInstall: !!app.dependencies && ((ref1 = app.dependencyData) === null || ref1 === void 0 ? void 0 : ref1.some((data)=>!data.installed)),
                        render: (param)=>{
                            let { useDefaultComponent , ...props } = param;
                            if (useDefaultComponent) {
                                props = {
                                    ...props,
                                    onClick: ()=>{
                                        mutation.mutate({
                                            type: app.type,
                                            variant: app.variant,
                                            slug: app.slug
                                        });
                                    },
                                    disabled: !!props.disabled
                                };
                            }
                            return /*#__PURE__*/ _jsx(Button, {
                                StartIcon: FiPlus,
                                color: "secondary",
                                className: "[@media(max-width:260px)]:w-full [@media(max-width:260px)]:justify-center",
                                "data-testid": "install-app-button",
                                ...props,
                                children: "Install"
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "max-w-44 absolute right-0 mr-4 flex flex-wrap justify-end gap-1",
                children: [
                    appAdded > 0 && /*#__PURE__*/ _jsx("span", {
                        className: "rounded-md bg-green-100 px-2 py-1 text-sm font-normal text-green-800",
                        children: "Installed"
                    }),
                    app.isTemplate && /*#__PURE__*/ _jsx("span", {
                        className: "rounded-md bg-red-100 px-2 py-1 text-sm font-normal text-red-800",
                        children: "Template"
                    }),
                    (app.isDefault || !app.isDefault && app.isGlobal) && /*#__PURE__*/ _jsx("span", {
                        className: "flex items-center rounded-md bg-gray-100 px-2 py-1 text-sm font-normal text-gray-800",
                        children: "Default"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/apps/index.ts




;// CONCATENATED MODULE: ../../packages/ui/components/logo/Logo.tsx


function Logo_Logo(param) {
    let { small , icon  } = param;
    return /*#__PURE__*/ _jsx("h3", {
        className: "logo inline",
        children: /*#__PURE__*/ _jsx("strong", {
            children: icon ? /*#__PURE__*/ _jsx("img", {
                className: "mx-auto w-9",
                alt: "Billy",
                title: "Billy",
                src: LOGO
            }) : /*#__PURE__*/ _jsx("img", {
                className: small ? "h-4 w-auto" : "h-6 w-auto",
                alt: "Billy",
                title: "Billy",
                src: LOGO
            })
        })
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/logo/index.ts


// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-dialog/dist/index.module.js + 9 modules
var dist_index_module = __webpack_require__(4947);
;// CONCATENATED MODULE: ../../packages/ui/components/dialog/Dialog.tsx






function Dialog(props) {
    const router = useRouter();
    const { children , name , ...dialogProps } = props;
    // only used if name is set
    const [open, setOpen] = useState(!!dialogProps.open);
    if (name) {
        const clearQueryParamsOnClose = [
            "dialog",
            ...props.clearQueryParamsOnClose || []
        ];
        dialogProps.onOpenChange = (open)=>{
            if (props.onOpenChange) {
                props.onOpenChange(open);
            }
            // toggles "dialog" query param
            if (open) {
                router.query["dialog"] = name;
            } else {
                const query = router.query;
                clearQueryParamsOnClose.forEach((queryParam)=>{
                    delete query[queryParam];
                });
                router.push({
                    pathname: router.pathname,
                    query
                }, undefined, {
                    shallow: true
                });
            }
            setOpen(open);
        };
        // handles initial state
        if (!open && router.query["dialog"] === name) {
            setOpen(true);
        }
        // allow overriding
        if (!("open" in dialogProps)) {
            dialogProps.open = open;
        }
    }
    return /*#__PURE__*/ _jsx(DialogPrimitive.Root, {
        ...dialogProps,
        children: children
    });
}
// enableOverflow:- use this prop whenever content inside DialogContent could overflow and require scrollbar
const Dialog_DialogContent = /*#__PURE__*/ react.forwardRef((param, forwardedRef)=>{
    let { children , title , Icon , enableOverflow , type ="creation" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_module/* Portal */.h_, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Overlay */.aV, {
                className: "fadeIn fixed inset-0 bg-gray-500 bg-opacity-80 transition-opacity"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_module/* Content */.VY, {
                ...props,
                className: classNames_classNames("fadeIn fixed left-1/2 top-1/2 min-w-[360px] -translate-x-1/2 -translate-y-1/2 rounded bg-white text-left shadow-xl focus-visible:outline-none sm:w-full sm:align-middle", props.size == "xl" ? "p-8 sm:max-w-[90rem]" : props.size == "lg" ? "p-8 sm:max-w-[70rem]" : props.size == "md" ? "p-8 sm:max-w-[48rem]" : "p-8 sm:max-w-[35rem]", "max-h-[95vh]", enableOverflow ? "overflow-auto" : "overflow-visible", "".concat(props.className || "")),
                ref: forwardedRef,
                children: [
                    type === "creation" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogHeader, {
                                title: title,
                                subtitle: props.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col space-y-6",
                                children: children
                            })
                        ]
                    }),
                    type === "confirmation" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-4 inline-flex h-10 w-10 items-center justify-center rounded-full bg-gray-300",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    className: "h-4 w-4 text-black"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogHeader, {
                                        title: title,
                                        subtitle: props.description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-col space-y-6",
                                        children: children
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
function DialogHeader(props) {
    if (!props.title) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "leading-20 text-semibold font-cal pb-1 text-xl text-gray-900",
                id: "modal-title",
                children: props.title
            }),
            props.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm text-gray-500",
                children: props.subtitle
            })
        ]
    });
}
function DialogFooter(props) {
    return /*#__PURE__*/ _jsx("div", {
        className: "mt-7 flex justify-end space-x-2 rtl:space-x-reverse ",
        children: props.children
    });
}
Dialog_DialogContent.displayName = "DialogContent";
const DialogTrigger = dist_index_module/* Trigger */.xz;
// export const DialogClose = DialogPrimitive.Close;
function Dialog_DialogClose(props) {
    return /*#__PURE__*/ _jsx(DialogPrimitive.Close, {
        asChild: true,
        ...props.dialogCloseProps,
        children: /*#__PURE__*/ _jsx(Button, {
            color: props.color || "minimal",
            ...props,
            children: props.children ? props.children : "Close"
        })
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/dialog/ConfirmationDialogContent.tsx





function ConfirmationDialogContent(props) {
    const { title , variety , confirmButtonVisible =true , confirmBtn =null , confirmBtnText ="Confirm" , cancelBtnText ="Cancel" , loadingText ="Loading" , isLoading =false , onConfirm , children  } = props;
    return /*#__PURE__*/ _jsxs(DialogContent, {
        type: "creation",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex",
                children: [
                    variety && /*#__PURE__*/ _jsxs("div", {
                        className: "mt-0.5 mr-3",
                        children: [
                            variety === "danger" && /*#__PURE__*/ _jsx("div", {
                                className: "mx-auto rounded-full bg-red-100 p-2 text-center",
                                children: /*#__PURE__*/ _jsx(FiAlertCircle, {
                                    className: "h-5 w-5 text-red-600"
                                })
                            }),
                            variety === "warning" && /*#__PURE__*/ _jsx("div", {
                                className: "mx-auto rounded-full bg-orange-100 p-2 text-center",
                                children: /*#__PURE__*/ _jsx(FiAlertCircle, {
                                    className: "h-5 w-5 text-orange-600"
                                })
                            }),
                            variety === "success" && /*#__PURE__*/ _jsx("div", {
                                className: "mx-auto rounded-full bg-green-100 p-2 text-center",
                                children: /*#__PURE__*/ _jsx(FiCheck, {
                                    className: "h-5 w-5 text-green-600"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ _jsx(DialogPrimitive.Title, {
                                className: "font-cal text-lg text-gray-900",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx(DialogPrimitive.Content, {
                                className: "text-sm text-gray-500 w-full",
                                children: children
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-5 flex flex-row-reverse gap-x-2 sm:mt-8",
                children: [
                    confirmButtonVisible ? confirmBtn ? confirmBtn : /*#__PURE__*/ _jsx(DialogClose, {
                        color: "primary",
                        loading: isLoading,
                        onClick: (e)=>onConfirm && onConfirm(e),
                        children: isLoading ? loadingText : confirmBtnText
                    }) : null,
                    /*#__PURE__*/ _jsx(DialogClose, {
                        disabled: isLoading,
                        children: cancelBtnText
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/dialog/index.ts



;// CONCATENATED MODULE: ../../packages/ui/components/form/inputs/HintOrErrors.tsx



function HintOrErrors_HintsOrErrors(props) {
    const methods = useFormContext();
    /* If there's no methods it means we're using these components outside a React Hook Form context */ if (!methods) return null;
    const { formState  } = methods;
    const { hintErrors , fieldName , error  } = props;
    // This is temporary, we need to pass {t(`${fieldName}_hint_${key}`)} below
    if (error) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "text-gray mt-2 flex items-center text-sm text-red-700",
            children: [
                /*#__PURE__*/ _jsx(FiInfo, {
                    className: "mr-1 h-3 w-3"
                }),
                /*#__PURE__*/ _jsx(_Fragment, {
                    children: error
                })
            ]
        });
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const fieldErrors = formState === null || formState === void 0 ? void 0 : formState.errors[fieldName];
    if (!hintErrors && fieldErrors && !fieldErrors.message) {
        // no hints passed, field errors exist and they are custom ones
        return /*#__PURE__*/ _jsx("div", {
            className: "text-gray mt-2 flex items-center text-sm text-gray-700",
            children: /*#__PURE__*/ _jsx("ul", {
                className: "ml-2",
                children: Object.keys(fieldErrors).map((key)=>{
                    return /*#__PURE__*/ _jsx("li", {
                        className: "text-blue-700",
                        children: fieldName
                    }, key);
                })
            })
        });
    }
    if (hintErrors && fieldErrors) {
        // hints passed, field errors exist
        return /*#__PURE__*/ _jsx("div", {
            className: "text-gray mt-2 flex items-center text-sm text-gray-700",
            children: /*#__PURE__*/ _jsx("ul", {
                className: "ml-2",
                children: hintErrors.map((key)=>{
                    const submitted = formState.isSubmitted;
                    const error = fieldErrors[key] || fieldErrors.message;
                    return /*#__PURE__*/ _jsxs("li", {
                        className: error !== undefined ? submitted ? "text-red-700" : "" : "text-green-600",
                        children: [
                            error !== undefined ? submitted ? /*#__PURE__*/ _jsx(FiX, {
                                size: "12",
                                strokeWidth: "3",
                                className: "-ml-1 inline-block ltr:mr-2 rtl:ml-2"
                            }) : /*#__PURE__*/ _jsx(FiCircle, {
                                fill: "currentColor",
                                size: "5",
                                className: "inline-block ltr:mr-2 rtl:ml-2"
                            }) : /*#__PURE__*/ _jsx(FiCheck, {
                                size: "12",
                                strokeWidth: "3",
                                className: "-ml-1 inline-block ltr:mr-2 rtl:ml-2"
                            }),
                            fieldName
                        ]
                    }, key);
                })
            })
        });
    }
    // errors exist, not custom ones, just show them as is
    if (fieldErrors) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "text-gray mt-2 flex items-center text-sm text-red-700",
            children: [
                /*#__PURE__*/ _jsx(FiInfo, {
                    className: "mr-1 h-3 w-3"
                }),
                /*#__PURE__*/ _jsx(_Fragment, {
                    children: fieldErrors.message
                })
            ]
        });
    }
    if (!hintErrors) return null;
    // hints passed, no errors exist, proceed to just show hints
    return /*#__PURE__*/ _jsx("div", {
        className: "text-gray mt-2 flex items-center text-sm text-gray-700",
        children: /*#__PURE__*/ _jsx("ul", {
            className: "ml-2",
            children: hintErrors.map((key)=>{
                // if field was changed, as no error exist, show checked status and color
                const dirty = formState.dirtyFields[fieldName];
                return /*#__PURE__*/ _jsxs("li", {
                    className: !!dirty ? "text-green-600" : "",
                    children: [
                        !!dirty ? /*#__PURE__*/ _jsx(FiCheck, {
                            size: "12",
                            strokeWidth: "3",
                            className: "-ml-1 inline-block ltr:mr-2 rtl:ml-2"
                        }) : /*#__PURE__*/ _jsx(FiCircle, {
                            fill: "currentColor",
                            size: "5",
                            className: "inline-block ltr:mr-2 rtl:ml-2"
                        }),
                        fieldName
                    ]
                }, key);
            })
        })
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/form/inputs/Label.tsx


function Label_Label(props) {
    return /*#__PURE__*/ _jsx("label", {
        ...props,
        className: classNames("mb-2 block text-sm font-medium leading-none text-gray-700", props.className),
        children: props.children
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/form/inputs/Input.tsx









const PlainForm = (props, ref)=>{
    const { form , handleSubmit , ...passThrough } = props;
    return /*#__PURE__*/ _jsx(FormProvider, {
        ...form,
        children: /*#__PURE__*/ _jsx("form", {
            ref: ref,
            onSubmit: (event)=>{
                event.preventDefault();
                event.stopPropagation();
                form.handleSubmit(handleSubmit)(event).catch((err)=>{
                    showToast("".concat(getErrorFromUnknown(err).message), "error");
                });
            },
            ...passThrough,
            children: props.children
        })
    });
};
const Form = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(PlainForm)));
const Addon = (param)=>/*#__PURE__*/ {
    let { isFilled , children , className , error  } = param;
    return _jsx("div", {
        className: classNames("addon-wrapper h-9 border border-gray-300 px-3", isFilled && "bg-gray-100", className),
        children: /*#__PURE__*/ _jsx("div", {
            className: classNames("flex h-full flex-col justify-center text-sm", error && "text-red-900"),
            children: /*#__PURE__*/ _jsx("span", {
                className: "whitespace-nowrap py-2.5",
                children: children
            })
        })
    });
};
const Input = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function Input(param, ref) {
    let { isFullWidth =true , ...props } = param;
    return /*#__PURE__*/ _jsx("input", {
        ...props,
        ref: ref,
        className: classNames("mb-2 block h-9 rounded-md border border-gray-300 py-2 px-3 text-sm placeholder:text-gray-400 hover:border-gray-400 focus:border-neutral-300 focus:outline-none focus:ring-2 focus:ring-neutral-800 focus:ring-offset-1", isFullWidth && "w-full", props.className)
    });
})));
const TextField = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function TextField(props, ref) {
    return /*#__PURE__*/ _jsx(InputField, {
        ref: ref,
        ...props
    });
})));
const InputField = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function InputField(props, ref) {
    const id = useId();
    // const { t: _t, isLocaleReady, i18n } = useLocale();
    // const t = props.t || _t;
    const name = props.name || "";
    const { // label = t(name),
    label , labelProps , labelClassName , // placeholder = isLocaleReady && i18n.exists(name + "_placeholder") ? t(name + "_placeholder") : "",
    placeholder , className , addOnLeading , addOnSuffix , addOnFilled =true , addOnClassname , inputIsFullWidth , hint , type , hintErrors , labelSrOnly , containerClassName , readOnly , error , hideError , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // t: __t,
    ...passThrough } = props;
    const [inputValue, setInputValue] = useState("");
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(containerClassName),
        children: [
            !!name && label && /*#__PURE__*/ _jsx(Skeleton, {
                as: Label,
                htmlFor: id,
                loadingClassName: "w-16",
                ...labelProps,
                className: classNames(labelClassName, labelSrOnly && "sr-only", props.error && "text-red-900"),
                children: label
            }),
            addOnLeading || addOnSuffix ? /*#__PURE__*/ _jsxs("div", {
                className: "relative mb-1 flex items-center rounded-md focus-within:outline-none focus-within:ring-2 focus-within:ring-neutral-800 focus-within:ring-offset-1",
                children: [
                    addOnLeading && /*#__PURE__*/ _jsx(Addon, {
                        isFilled: addOnFilled,
                        className: classNames("rounded-l-md border-r-0", addOnClassname),
                        children: addOnLeading
                    }),
                    /*#__PURE__*/ _jsx(Input, {
                        id: id,
                        type: type,
                        placeholder: placeholder,
                        isFullWidth: inputIsFullWidth,
                        className: classNames(className, addOnLeading && "rounded-l-none", addOnSuffix && "rounded-r-none", type === "search" && "pr-8", props.error && "border-red-900", "!my-0 !ring-0"),
                        ...passThrough,
                        ...type == "search" && {
                            onChange: (e)=>{
                                setInputValue(e.target.value);
                                props.onChange && props.onChange(e);
                            },
                            value: inputValue
                        },
                        readOnly: readOnly,
                        ref: ref
                    }),
                    addOnSuffix && /*#__PURE__*/ _jsx(Addon, {
                        isFilled: addOnFilled,
                        className: classNames("rounded-r-md border-l-0", addOnClassname),
                        children: addOnSuffix
                    }),
                    type === "search" && (inputValue === null || inputValue === void 0 ? void 0 : inputValue.toString().length) > 0 && /*#__PURE__*/ _jsx(FiX, {
                        className: "absolute top-2.5 h-4 w-4 cursor-pointer text-gray-500 ltr:right-2 rtl:left-2",
                        onClick: (e)=>{
                            setInputValue("");
                            props.onChange && props.onChange(e);
                        }
                    })
                ]
            }) : /*#__PURE__*/ _jsx(Input, {
                id: id,
                type: type,
                placeholder: placeholder,
                className: classNames(className, props.error && "border-red-900"),
                ...passThrough,
                ref: ref,
                isFullWidth: inputIsFullWidth
            }),
            !hideError && /*#__PURE__*/ _jsx(HintsOrErrors, {
                hintErrors: hintErrors,
                fieldName: name,
                error: error
            }),
            hint && /*#__PURE__*/ _jsx("div", {
                className: "text-gray mt-2 flex items-center text-sm text-gray-700",
                children: hint
            })
        ]
    });
})));
const TextArea = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function TextAreaInput(props, ref) {
    return /*#__PURE__*/ _jsx("textarea", {
        ref: ref,
        ...props,
        className: classNames("block w-full rounded-md border border-gray-300 py-2 px-3 text-sm hover:border-gray-400 focus:border-neutral-300 focus:outline-none focus:ring-2 focus:ring-neutral-800 focus:ring-offset-1", props.className)
    });
})));
const TextAreaField = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function TextField(props, ref) {
    var ref1, ref2;
    const id = useId();
    const methods = useFormContext();
    const { label , labelProps , /** Prevents displaying untranslated placeholder keys */ placeholder , name , hintErrors , ...passThrough } = props;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            !!props.name && /*#__PURE__*/ _jsx(Label, {
                htmlFor: id,
                ...labelProps,
                children: label
            }),
            /*#__PURE__*/ _jsx(TextArea, {
                ref: ref,
                placeholder: placeholder,
                ...passThrough
            }),
            ((ref2 = methods === null || methods === void 0 ? void 0 : (ref1 = methods.formState) === null || ref1 === void 0 ? void 0 : ref1.errors[props.name]) === null || ref2 === void 0 ? void 0 : ref2.message) && /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx(HintsOrErrors, {
                    hintErrors: hintErrors,
                    fieldName: name
                })
            })
        ]
    });
})));

;// CONCATENATED MODULE: ../../packages/ui/components/form/select/components.tsx




const components_InputComponent = (param)=>{
    let { inputClassName , ...props } = param;
    return /*#__PURE__*/ _jsx(reactSelectComponents.Input, {
        // disables our default form focus hightlight on the react-select input element
        inputClassName: classNames("focus:ring-0 focus:ring-offset-0 dark:!text-darkgray-900 !text-black", inputClassName),
        ...props
    });
};
const components_OptionComponent = (param)=>{
    let { className , ...props } = param;
    return /*#__PURE__*/ _jsx(reactSelectComponents.Option, {
        ...props,
        className: classNames(className, "dark:bg-darkgray-100 !flex !cursor-pointer justify-between !py-3", props.isFocused && "dark:!bg-darkgray-200 !bg-gray-100", props.isSelected && "dark:!bg-darkgray-300 !bg-neutral-900"),
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "mr-auto",
                    children: props.label
                }),
                props.isSelected && /*#__PURE__*/ _jsx(FiCheck, {
                    className: "ml-2 h-4 w-4"
                })
            ]
        })
    });
};
const components_ControlComponent = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return _jsx(reactSelectComponents.Control, {
        ...props,
        className: classNames(className, "!rounded-md dark:bg-darkgray-100 dark:border-darkgray-300 border-gray-300 bg-white text-sm leading-4 placeholder:text-sm placeholder:font-normal focus-within:border-0 focus-within:ring-2 focus-within:ring-neutral-800 hover:border-neutral-400 dark:focus-within:ring-white")
    });
};
const components_SingleValueComponent = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return _jsx(reactSelectComponents.SingleValue, {
        ...props,
        className: classNames(className, "dark:text-darkgray-900 dark:placeholder:text-darkgray-500 text-black placeholder:text-gray-400")
    });
};
const components_ValueContainerComponent = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return _jsx(reactSelectComponents.ValueContainer, {
        ...props,
        className: classNames("dark:text-darkgray-900 dark:placeholder:text-darkgray-500 text-black placeholder:text-gray-400", className)
    });
};
const components_MultiValueComponent = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return _jsx(reactSelectComponents.MultiValue, {
        ...props,
        className: classNames("dark:bg-darkgray-200 dark:text-darkgray-900 !rounded-md bg-gray-100 text-gray-700", className)
    });
};
const components_MenuComponent = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return _jsx(reactSelectComponents.Menu, {
        ...props,
        className: classNames("dark:bg-darkgray-100 !rounded-md bg-white text-sm leading-4 dark:text-white", className)
    });
};
const components_MenuListComponent = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return _jsx(reactSelectComponents.MenuList, {
        ...props,
        className: classNames("scrollbar-thin scrollbar-thumb-rounded-md dark:scrollbar-thumb-darkgray-300 scrollbar-thumb-gray-300 scrollbar-track-transparent scrollbar-track-w-[80px] rounded-md", className)
    });
};

;// CONCATENATED MODULE: ../../packages/ui/components/form/select/Select.tsx







const getReactSelectProps = (param)=>{
    let { className , components , menuPlacement ="auto"  } = param;
    return {
        menuPlacement,
        className: classNames("block min-h-[36px] w-full min-w-0 flex-1 rounded-md", className),
        classNamePrefix: "cal-react-select",
        components: {
            ...reactSelectComponents,
            IndicatorSeparator: ()=>null,
            Input: InputComponent,
            Option: OptionComponent,
            Control: ControlComponent,
            SingleValue: SingleValueComponent,
            Menu: MenuComponent,
            MenuList: MenuListComponent,
            ValueContainer: ValueContainerComponent,
            MultiValue: MultiValueComponent,
            ...components
        }
    };
};
const Select_Select = (param)=>{
    let { className , components , styles , ...props } = param;
    const { error  } = props;
    const reactSelectProps = React.useMemo(()=>{
        return getReactSelectProps({
            className,
            components: components || {}
        });
    }, [
        className,
        components
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ReactSelect, {
                ...reactSelectProps,
                ...props,
                styles: {
                    option: (defaultStyles, state)=>({
                            ...defaultStyles,
                            backgroundColor: state.isSelected ? state.isFocused ? "var(--brand-color)" : "var(--brand-color)" : state.isFocused ? "var(--brand-color-dark-mode)" : "var(--brand-text-color)"
                        }),
                    ...styles
                }
            }),
            error && /*#__PURE__*/ _jsx("div", {
                className: "text-gray mt-2 flex items-center text-sm text-red-700",
                children: /*#__PURE__*/ _jsx(_Fragment, {
                    children: error.message
                })
            })
        ]
    });
};
const IconLeading = (param)=>{
    let { icon , children , ...props } = param;
    return /*#__PURE__*/ _jsxs(reactSelectComponents.Control, {
        ...props,
        children: [
            icon,
            children
        ]
    });
};
const SelectField = function SelectField(props) {
    const { label , containerClassName , labelProps , className , ...passThrough } = props;
    const id = useId();
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(containerClassName),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classNames(className),
                children: !!label && /*#__PURE__*/ _jsx(Label, {
                    htmlFor: id,
                    ...labelProps,
                    className: classNames(props.error && "text-red-900"),
                    children: label
                })
            }),
            /*#__PURE__*/ _jsx(Select_Select, {
                ...passThrough
            })
        ]
    });
};
/**
 * TODO: It should replace Select after through testing
 */ function SelectWithValidation(param) {
    let { required =false , onChange , value , ...remainingProps } = param;
    const [hiddenInputValue, _setHiddenInputValue] = React.useState(()=>{
        if (value instanceof Array || !value) {
            return;
        }
        return value.value || "";
    });
    const setHiddenInputValue = React.useCallback((value)=>{
        let hiddenInputValue = "";
        if (value instanceof Array) {
            hiddenInputValue = value.map((val)=>val.value).join(",");
        } else {
            hiddenInputValue = (value === null || value === void 0 ? void 0 : value.value) || "";
        }
        _setHiddenInputValue(hiddenInputValue);
    }, []);
    React.useEffect(()=>{
        if (!value) {
            return;
        }
        setHiddenInputValue(value);
    }, [
        value,
        setHiddenInputValue
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("relative", remainingProps.className),
        children: [
            /*#__PURE__*/ _jsx(Select_Select, {
                value: value,
                ...remainingProps,
                onChange: function(value) {
                    for(var _len = arguments.length, remainingArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        remainingArgs[_key - 1] = arguments[_key];
                    }
                    setHiddenInputValue(value);
                    if (onChange) {
                        onChange(value, ...remainingArgs);
                    }
                }
            }),
            required && /*#__PURE__*/ _jsx("input", {
                tabIndex: -1,
                autoComplete: "off",
                style: {
                    opacity: 0,
                    width: "100%",
                    height: 1,
                    position: "absolute"
                },
                value: hiddenInputValue,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onChange: ()=>{},
                // TODO:Not able to get focus to work
                // onFocus={() => selectRef.current?.focus()}
                required: required
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/form/select/index.ts


;// CONCATENATED MODULE: ../../packages/ui/components/form/color-picker/colorpicker.tsx





function useEventListener(eventName, handler, element) {
    // Create a ref that stores handler
    const savedHandler = useRef();
    useEffect(()=>{
        // Define the listening target
        const targetElement = (element === null || element === void 0 ? void 0 : element.current) || window;
        if (!(targetElement && targetElement.addEventListener)) {
            return;
        }
        // Update saved handler if necessary
        if (savedHandler.current !== handler) {
            savedHandler.current = handler;
        }
        // Create event listener that calls handler function stored in ref
        const eventListener = (event)=>{
            // eslint-disable-next-line no-extra-boolean-cast
            if (!!(savedHandler === null || savedHandler === void 0 ? void 0 : savedHandler.current)) {
                savedHandler.current(event);
            }
        };
        targetElement.addEventListener(eventName, eventListener);
        // Remove event listener on cleanup
        return ()=>{
            targetElement.removeEventListener(eventName, eventListener);
        };
    }, [
        eventName,
        element,
        handler
    ]);
}
function useOnClickOutside(ref, handler) {
    let mouseEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "mousedown";
    useEventListener(mouseEvent, (event)=>{
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        // Do nothing if clicking ref's element or descendent elements
        if (!el || el.contains(event.target)) {
            return;
        }
        handler(event);
    });
}
const ColorPicker = (props)=>{
    const init = !isValidHexCode(props.defaultValue) ? fallBackHex(props.defaultValue, false) : props.defaultValue;
    const [color, setColor] = useState(init);
    const [isOpen, toggle] = useState(false);
    const popover = useRef();
    const close = useCallback(()=>toggle(false), []);
    useOnClickOutside(popover, close);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative mt-1 flex items-center justify-center",
        children: [
            /*#__PURE__*/ _jsx(Swatch, {
                size: "sm",
                backgroundColor: color,
                onClick: ()=>toggle(!isOpen)
            }),
            isOpen && /*#__PURE__*/ _jsx("div", {
                className: "popover",
                ref: popover,
                children: /*#__PURE__*/ _jsx(HexColorPicker, {
                    className: "!absolute !top-10 !left-0 !z-10 !h-32 !w-32",
                    color: color,
                    onChange: (val)=>{
                        setColor(val);
                        props.onChange(val);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(HexColorInput, {
                className: "block w-full border border-gray-300 hover:border-gray-400 focus:border-neutral-300 focus:outline-none focus:ring-2 focus:ring-neutral-800 focus:ring-offset-1 border-l-0 px-3 py-2 rounded-r-md sm:text-sm",
                color: color,
                onChange: (val)=>{
                    setColor(val);
                    props.onChange(val);
                },
                type: "text"
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@heroicons/react/outline/esm/CheckCircleIcon.js
var esm_CheckCircleIcon = __webpack_require__(6106);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-dropdown-menu/dist/index.module.js + 23 modules
var react_dropdown_menu_dist_index_module = __webpack_require__(628);
;// CONCATENATED MODULE: ../../packages/ui/components/form/dropdown/Dropdown.tsx






const Dropdown = react_dropdown_menu_dist_index_module/* Root */.fC;
const DropdownMenuTrigger = /*#__PURE__*/ (0,react.forwardRef)((param, forwardedRef)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)(react_dropdown_menu_dist_index_module/* Trigger */.xz, {
        ...props,
        className: classNames_classNames(!props.asChild && "inline-flex items-center rounded-md bg-transparent px-3 py-2 text-sm font-medium text-gray-700 ring-0 hover:bg-gray-50 focus:bg-gray-100 group-hover:text-black ".concat(className)),
        ref: forwardedRef
    });
});
DropdownMenuTrigger.displayName = "DropdownMenuTrigger";
const DropdownMenuTriggerItem = react_dropdown_menu_dist_index_module/* Trigger */.xz;
const DropdownMenuPortal = react_dropdown_menu_dist_index_module/* Portal */.Uv;
const DropdownMenuContent = /*#__PURE__*/ (0,react.forwardRef)((param, forwardedRef)=>{
    let { children , sideOffset =2 , align ="end" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dropdown_menu_dist_index_module/* Content */.VY, {
        align: align,
        ...props,
        sideOffset: sideOffset,
        className: classNames_classNames("shadow-dropdown w-[190px] relative z-10 origin-top-right rounded-md border border-gray-200 bg-white text-sm p-1"),
        ref: forwardedRef,
        children: children
    });
});
DropdownMenuContent.displayName = "DropdownMenuContent";
const DropdownMenuLabel = (props)=>/*#__PURE__*/ _jsx(DropdownMenuPrimitive.Label, {
        ...props,
        className: "px-3 py-2 text-gray-500"
    });
const DropdownMenuItem = /*#__PURE__*/ (0,react.forwardRef)((param, forwardedRef)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)(react_dropdown_menu_dist_index_module/* Item */.ck, {
        className: "focus:ring-transparent text-sm text-gray-700 ring-inset first-of-type:rounded-t-[inherit] last-of-type:rounded-b-[inherit] hover:bg-transparent hover:text-gray-900 focus:outline-none focus:ring-1 ".concat(className),
        ...props,
        ref: forwardedRef
    });
});
DropdownMenuItem.displayName = "DropdownMenuItem";
const DropdownMenuGroup = react_dropdown_menu_dist_index_module/* Group */.ZA;
const DropdownMenuCheckboxItem = /*#__PURE__*/ (0,react.forwardRef)((param, forwardedRef)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dropdown_menu_dist_index_module/* CheckboxItem */.oC, {
        ...props,
        ref: forwardedRef,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dropdown_menu_dist_index_module/* ItemIndicator */.wU, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckCircleIcon/* default */.Z, {})
            })
        ]
    });
});
DropdownMenuCheckboxItem.displayName = "DropdownMenuCheckboxItem";
const DropdownMenuRadioGroup = react_dropdown_menu_dist_index_module/* RadioGroup */.Ee;
const DropdownMenuRadioItem = /*#__PURE__*/ (0,react.forwardRef)((param, forwardedRef)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dropdown_menu_dist_index_module/* RadioItem */.Rk, {
        ...props,
        ref: forwardedRef,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dropdown_menu_dist_index_module/* ItemIndicator */.wU, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckCircleIcon/* default */.Z, {})
            })
        ]
    });
});
DropdownMenuRadioItem.displayName = "DropdownMenuRadioItem";
function ButtonOrLink(param) {
    let { href , ...props } = param;
    const isLink = typeof href !== "undefined";
    const ButtonOrLink = isLink ? "a" : "button";
    const content = /*#__PURE__*/ _jsx(ButtonOrLink, {
        ...props
    });
    if (isLink) {
        return /*#__PURE__*/ _jsx(Link, {
            href: href,
            legacyBehavior: true,
            children: content
        });
    }
    return content;
}
const DropdownItem = (props)=>{
    const { StartIcon , EndIcon , children , color , ...rest } = props;
    return /*#__PURE__*/ _jsx(ButtonOrLink, {
        ...rest,
        className: classNames("rounded inline-flex w-full items-center px-2 py-2 text-gray-700 hover:text-gray-900 disabled:cursor-not-allowed", color === "destructive" ? "hover:bg-red-100 hover:text-red-700" : "hover:bg-gray-100"),
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                StartIcon && /*#__PURE__*/ _jsx(StartIcon, {
                    className: "h-4 w-4"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mx-2 text-sm font-medium leading-5",
                    children: children
                }),
                EndIcon && /*#__PURE__*/ _jsx(EndIcon, {
                    className: "h-4 w-4"
                })
            ]
        })
    });
};
const DropdownMenuSeparator = /*#__PURE__*/ (0,react.forwardRef)((param, forwardedRef)=>{
    let { className ="" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dropdown_menu_dist_index_module/* Separator */.Z0, {
        className: classNames_classNames("my-1 h-px bg-gray-200", className),
        ...props,
        ref: forwardedRef
    });
});
DropdownMenuSeparator.displayName = "DropdownMenuSeparator";
/* harmony default export */ var dropdown_Dropdown = ((/* unused pure expression or super */ null && (Dropdown)));

;// CONCATENATED MODULE: ../../packages/ui/components/form/dropdown/index.ts


;// CONCATENATED MODULE: ../../packages/ui/components/form/switch/Switch.tsx






const Switch_Switch = (props)=>{
    var ref;
    const { label , fitToHeight , ...primitiveProps } = props;
    const id = useId();
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("flex h-auto w-auto flex-row items-center", fitToHeight && "h-fit"),
        children: [
            /*#__PURE__*/ _jsx(PrimitiveSwitch.Root, {
                className: classNames(props.checked ? "bg-gray-900" : "bg-gray-200", primitiveProps.disabled ? "cursor-not-allowed" : "hover:bg-gray-300", "focus:ring-brand-800 h-5 w-[34px] rounded-full shadow-none", props.className),
                ...primitiveProps,
                children: /*#__PURE__*/ _jsx(PrimitiveSwitch.Thumb, {
                    id: id,
                    // Since we dont support global dark mode - we have to style dark mode components specifically on the instance for now
                    // TODO: Remove once we support global dark mode
                    className: classNames("block h-[14px] w-[14px] rounded-full bg-white transition will-change-transform translate-x-[4px] [&[data-state='checked']]:translate-x-[17px]", props.checked && "shadow-inner", (ref = props.thumbProps) === null || ref === void 0 ? void 0 : ref.className)
                })
            }),
            label && /*#__PURE__*/ _jsx(Label.Root, {
                htmlFor: id,
                className: classNames("align-text-top text-sm font-medium text-gray-900 ml-3 dark:text-white", primitiveProps.disabled ? "cursor-not-allowed opacity-25" : "cursor-pointer "),
                children: label
            })
        ]
    });
};
/* harmony default export */ var switch_Switch = ((/* unused pure expression or super */ null && (Switch_Switch)));

// EXTERNAL MODULE: ../../node_modules/@formkit/auto-animate/react/index.mjs + 1 modules
var auto_animate_react = __webpack_require__(7049);
;// CONCATENATED MODULE: ../../packages/ui/components/form/switch/SettingsToggle.tsx





function SettingsToggle(param) {
    let { checked , onCheckedChange , description , title , children , disabled , reverse , image , ...rest } = param;
    const [animateRef] = useAutoAnimate();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex w-full flex-col space-y-4 lg:flex-row lg:space-y-0 lg:space-x-4",
            children: /*#__PURE__*/ _jsxs("fieldset", {
                className: "block w-full flex-col sm:flex",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: classNames("flex ", reverse ? "justify-between flex-row-reverse" : "space-x-3"),
                            children: [
                                /*#__PURE__*/ _jsx(Switch, {
                                    "data-testid": rest["data-testid"],
                                    fitToHeight: true,
                                    checked: checked,
                                    onCheckedChange: onCheckedChange,
                                    disabled: disabled
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex",
                                    children: [
                                        image ? /*#__PURE__*/ _jsx("div", {
                                            className: "inline-block mr-3 h-auto w-10 rounded-sm",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: image,
                                                alt: title
                                            })
                                        }) : null,
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx(Label, {
                                                    className: "text-sm font-semibold leading-none text-black",
                                                    children: title
                                                }),
                                                description && /*#__PURE__*/ _jsx("p", {
                                                    className: "-mt-1.5 text-sm leading-normal text-gray-500",
                                                    children: description
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    children && /*#__PURE__*/ _jsx("div", {
                        ref: animateRef,
                        children: checked && /*#__PURE__*/ _jsx("div", {
                            className: "mt-4",
                            children: children
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var switch_SettingsToggle = ((/* unused pure expression or super */ null && (SettingsToggle)));

;// CONCATENATED MODULE: ../../packages/ui/components/form/switch/index.ts



;// CONCATENATED MODULE: ../../packages/ui/components/form/checkbox/Checkbox.tsx



const CheckboxField = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { label , description , error , disabled , ...rest } = param;
    const descriptionAsLabel = !label || rest.descriptionAsLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "block items-center sm:flex",
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-w-48 mb-4 sm:mb-0",
                children: /*#__PURE__*/ react.createElement(descriptionAsLabel ? "div" : "label", {
                    className: classNames_classNames("flex text-sm font-medium text-gray-900"),
                    ...!descriptionAsLabel ? {
                        htmlFor: rest.id
                    } : {}
                }, label)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative flex items-start",
                    children: /*#__PURE__*/ react.createElement(descriptionAsLabel ? "label" : "div", {
                        className: classNames_classNames("relative flex items-start", !error && descriptionAsLabel ? "text-gray-900" : "text-gray-900", error && "text-red-800")
                    }, /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex h-5 items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    ...rest,
                                    ref: ref,
                                    type: "checkbox",
                                    disabled: disabled,
                                    className: classNames_classNames("text-primary-600 focus:ring-primary-500 h-4 w-4 rounded border-gray-300 mr-2 ", !error && disabled ? "bg-gray-300 checked:bg-gray-300" : "checked:bg-gray-800 hover:bg-gray-100", error && "border-red-800 checked:bg-red-800 hover:bg-red-400", rest.className)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm",
                                children: description
                            })
                        ]
                    }))
                })
            })
        ]
    });
});
CheckboxField.displayName = "CheckboxField";
/* harmony default export */ var Checkbox = ((/* unused pure expression or super */ null && (CheckboxField)));

;// CONCATENATED MODULE: ../../packages/ui/components/form/checkbox/MultiSelectCheckboxes.tsx





const InputOption = (param)=>{
    let { isDisabled , isFocused , isSelected , children , innerProps , className , ...rest } = param;
    const props = {
        ...innerProps
    };
    return /*#__PURE__*/ _jsxs(components.Option, {
        className: classNames(className, "dark:bg-darkgray-100 !flex !cursor-pointer !py-3 text-[inherit]", isFocused && "dark:!bg-darkgray-200 !bg-gray-100", isSelected && "dark:!bg-darkgray-300 !bg-neutral-900"),
        ...rest,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isSelected: isSelected,
        innerProps: props,
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: "checkbox",
                className: "text-primary-600 focus:ring-primary-500 h-4 w-4 rounded border-gray-300 ltr:mr-2 rtl:ml-2",
                checked: isSelected,
                readOnly: true
            }),
            children
        ]
    });
};
const MultiValue = (param)=>{
    let { index , getValue  } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: !index && /*#__PURE__*/ _jsx("div", {
            children: "nr_event_type"
        })
    });
// return <>{!index && <div>{t("nr_event_type", { count: getValue().length })}</div>}</>;
};
function MultiSelectCheckboxes(param) {
    let { options , isLoading , selected , setSelected , setValue , className  } = param;
    const additonalComponents = {
        MultiValue
    };
    return /*#__PURE__*/ _jsx(Select, {
        value: selected,
        onChange: (s)=>{
            setSelected(s);
            setValue(s);
        },
        options: options,
        isMulti: true,
        className: classNames(className ? className : "w-64 text-sm"),
        isSearchable: false,
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isLoading: isLoading,
        components: {
            ...additonalComponents,
            Option: InputOption
        }
    });
}

;// CONCATENATED MODULE: ../../packages/ui/components/form/checkbox/index.ts



;// CONCATENATED MODULE: ../../packages/ui/components/form/toggleGroup/ToggleGroup.tsx




const ToggleGroupItem = ()=>/*#__PURE__*/ _jsx("div", {
        children: "hi"
    });
const ToggleGroup = (param)=>{
    let { options , onValueChange , isFullWidth , ...props } = param;
    const [value, setValue] = useState(props.defaultValue);
    const [activeToggleElement, setActiveToggleElement] = useState(null);
    useEffect(()=>{
        if (value && onValueChange) onValueChange(value);
    }, [
        value,
        onValueChange
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(RadixToggleGroup.Root, {
            type: "single",
            ...props,
            onValueChange: setValue,
            className: classNames("dark:border-darkgray-200 relative inline-flex rounded-md border border-gray-200 p-1", props.className, isFullWidth && "w-full"),
            children: [
                /*#__PURE__*/ _jsx("span", {
                    "aria-hidden": true,
                    className: "dark:bg-darkgray-200 absolute top-[4px] bottom-[4px] left-0 z-[0] rounded-[4px] bg-gray-200 transition-all",
                    style: {
                        left: activeToggleElement === null || activeToggleElement === void 0 ? void 0 : activeToggleElement.offsetLeft,
                        width: activeToggleElement === null || activeToggleElement === void 0 ? void 0 : activeToggleElement.offsetWidth
                    }
                }),
                options.map((option)=>/*#__PURE__*/ _jsx(RadixToggleGroup.Item, {
                        disabled: option.disabled,
                        value: option.value,
                        className: classNames("relative rounded-[4px] px-3 py-1 text-sm", option.disabled ? "dark:text-darkgray-900 text-gray-400 hover:cursor-not-allowed" : "dark:text-darkgray-800 [&[aria-checked='false']]:hover:font-medium", isFullWidth && "w-full"),
                        ref: (node)=>{
                            if (node && value === option.value) {
                                setActiveToggleElement(node);
                            }
                            return node;
                        },
                        children: option.label
                    }, option.value))
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../packages/ui/components/form/toggleGroup/BooleanToggleGroup.tsx






const BooleanToggleGroup_boolean = (yesNo)=>yesNo === "yes" ? true : yesNo === "no" ? false : undefined;
const yesNo = (boolean)=>boolean === true ? "yes" : boolean === false ? "no" : undefined;
const BooleanToggleGroup = function BooleanToggleGroup(param) {
    let { defaultValue =true , value , disabled =false , // eslint-disable-next-line @typescript-eslint/no-empty-function
    onValueChange =()=>{}  } = param;
    // Maintain a state because it is not necessary that onValueChange the parent component would re-render. Think react-hook-form
    // Also maintain a string as boolean isn't accepted as ToggleGroupPrimitive value
    const [yesNoValue, setYesNoValue] = useState(yesNo(value));
    if (!yesNoValue) {
        setYesNoValue(yesNo(defaultValue));
        onValueChange(defaultValue);
        return null;
    }
    const commonClass = "mb-2 inline-flex items-center justify-center rounded-md py-[10px] px-4 text-sm font-medium  leading-4 md:mb-0";
    const selectedClass = classNames(commonClass, "bg-gray-200  text-gray-900");
    const unselectedClass = classNames(commonClass, "text-gray-600 hover:bg-gray-100 hover:text-gray-900");
    return /*#__PURE__*/ _jsxs(ToggleGroupPrimitive, {
        value: yesNoValue,
        type: "single",
        disabled: disabled,
        className: "space-x-2 rounded-sm rtl:space-x-reverse",
        onValueChange: (yesNoValue)=>{
            setYesNoValue(yesNoValue);
            onValueChange(BooleanToggleGroup_boolean(yesNoValue));
        },
        children: [
            /*#__PURE__*/ _jsx(ToggleGroupItemPrimitive, {
                className: classNames(BooleanToggleGroup_boolean(yesNoValue) ? selectedClass : unselectedClass),
                disabled: disabled,
                value: "yes",
                children: "Yes"
            }),
            /*#__PURE__*/ _jsx(ToggleGroupItemPrimitive, {
                disabled: disabled,
                className: classNames(!BooleanToggleGroup_boolean(yesNoValue) ? selectedClass : unselectedClass),
                value: "no",
                children: "No"
            })
        ]
    });
};
const BooleanToggleGroupField = function BooleanToggleGroupField(props) {
    const { label , containerClassName , labelProps , className , ...passThrough } = props;
    const id = useId();
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(containerClassName),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: className,
                children: !!label && /*#__PURE__*/ _jsx(Label, {
                    htmlFor: id,
                    ...labelProps,
                    className: classNames(props.error && "text-red-900", "mt-4"),
                    children: label
                })
            }),
            /*#__PURE__*/ _jsx(BooleanToggleGroup, {
                ...passThrough
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/components/form/toggleGroup/index.ts



;// CONCATENATED MODULE: ../../packages/ui/components/form/radio-area/RadioAreaGroup.tsx



const RadioAreaGroup_RadioArea = /*#__PURE__*/ react.forwardRef((param, ref)=>{
    let { children , className , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        className: classNames_classNames("relative flex", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: ref,
                className: "text-emphasis bg-subtle border-emphasis focus:ring-none peer absolute top-[0.9rem] left-3 align-baseline",
                type: "radio",
                ...props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-default peer-checked:border-emphasis border-subtle rounded-md border p-4 pt-3 pl-10",
                children: children
            })
        ]
    });
});
const RadioAreaGroup_RadioAreaGroup = (param)=>{
    let { children , className , onChange , ...passThroughProps } = param;
    const childrenWithProps = react.Children.map(children, (child)=>{
        if (onChange && /*#__PURE__*/ react.isValidElement(child)) {
            return /*#__PURE__*/ react.cloneElement(child, {
                onChange: (e)=>{
                    onChange(e.target.value);
                }
            });
        }
        return child;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        ...passThroughProps,
        children: childrenWithProps
    });
};
RadioAreaGroup_RadioAreaGroup.displayName = "RadioAreaGroup";
RadioAreaGroup_RadioArea.displayName = "RadioArea";
const Item = (/* unused pure expression or super */ null && (RadioAreaGroup_RadioArea));
const Group = (/* unused pure expression or super */ null && (RadioAreaGroup_RadioAreaGroup));


;// CONCATENATED MODULE: ../../packages/ui/components/form/radio-area/Select.tsx







const radio_area_Select_Select = function RadioAreaSelect(props) {
    const { options , form , disabled =!options.length , placeholder ="Select"  } = props;
    const getLabel = (value)=>{
        var ref;
        return (ref = options.find((option)=>option.value === value)) === null || ref === void 0 ? void 0 : ref.label;
    };
    var ref;
    return /*#__PURE__*/ _jsxs(Collapsible, {
        className: classNames("w-full", props.className),
        children: [
            /*#__PURE__*/ _jsxs(CollapsibleTrigger, {
                type: "button",
                disabled: disabled,
                className: classNames("focus:ring-primary-500 border-default bg-default mb-1 block w-full cursor-pointer rounded-sm border border p-2 text-left shadow-sm sm:text-sm", disabled && "bg-emphasis cursor-default focus:ring-0 "),
                children: [
                    (ref = getLabel(props.value)) !== null && ref !== void 0 ? ref : placeholder,
                    /*#__PURE__*/ _jsx(ChevronDownIcon, {
                        className: "text-subtle float-right h-5 w-5"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CollapsibleContent, {
                children: /*#__PURE__*/ _jsx(RadioAreaGroup, {
                    className: "space-y-2 text-sm",
                    onChange: props.onChange,
                    children: options.map((option)=>/*#__PURE__*/ _createElement(RadioArea, {
                            ...form.register(props.name),
                            ...option,
                            key: Array.isArray(option.value) ? option.value.join(",") : "".concat(option.value),
                            children: [
                                /*#__PURE__*/ _jsx("strong", {
                                    className: "mb-1 block",
                                    children: option.label
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    children: option.description
                                })
                            ]
                        }))
                })
            })
        ]
    });
};
/* harmony default export */ var radio_area_Select = ((/* unused pure expression or super */ null && (radio_area_Select_Select)));

;// CONCATENATED MODULE: ../../packages/ui/components/form/radio-area/Radio.tsx



const Radio_Group = (props)=>/*#__PURE__*/ _jsx(RadioGroupPrimitive.Root, {
        ...props,
        children: props.children
    });
const Radio = (props)=>/*#__PURE__*/ _jsx(RadioGroupPrimitive.Item, {
        ...props,
        className: classNames("hover:bg-subtle border-default focus:ring-emphasis mt-0.5 h-4 w-4 flex-shrink-0 rounded-full border focus:ring-2", props.disabled && "opacity-60"),
        children: props.children
    });
const Indicator = (param)=>/*#__PURE__*/ {
    let { disabled  } = param;
    return _jsx(RadioGroupPrimitive.Indicator, {
        className: classNames("after:bg-default dark:after:bg-inverted relative flex h-full w-full items-center justify-center rounded-full bg-black after:h-[6px] after:w-[6px] after:rounded-full after:content-['']", disabled ? "after:bg-muted" : "bg-black")
    });
};
const Radio_Label = (props)=>/*#__PURE__*/ _jsx("label", {
        ...props,
        className: classNames("text-emphasis ms-2 w-full text-sm font-medium leading-5", props.disabled && "text-subtle")
    });
const RadioField = (param)=>/*#__PURE__*/ {
    let { label , disabled , id , value , className  } = param;
    return _jsxs("div", {
        className: classNames("flex items-start", className),
        children: [
            /*#__PURE__*/ _jsx(Radio, {
                value: value,
                disabled: disabled,
                id: id,
                children: /*#__PURE__*/ _jsx(Indicator, {
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ _jsx(Radio_Label, {
                htmlFor: id,
                disabled: disabled,
                children: label
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui/components/form/radio-area/index.ts





;// CONCATENATED MODULE: ../../packages/ui/components/form/index.ts











;// CONCATENATED MODULE: ../../packages/ui/components/index.ts



















;// CONCATENATED MODULE: ../../packages/ui/components/swatch/Swatch.tsx


const Swatch_Swatch = (props)=>{
    const { size , backgroundColor , onClick  } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: "border border-gray-300 border-r-0 pl-2 py-2 h-[38px] flex items-center rounded-l-md",
        children: /*#__PURE__*/ _jsx("div", {
            onClick: onClick,
            style: {
                backgroundColor
            },
            className: classNames("cursor-pointer", size === "sm" && "h-4 w-4 rounded-sm", size === "base" && "h-16 w-16 rounded-sm", size === "lg" && "h-24 w-24 rounded-sm")
        })
    });
};
/* harmony default export */ var swatch_Swatch = ((/* unused pure expression or super */ null && (Swatch_Swatch)));

;// CONCATENATED MODULE: ../../packages/ui/components/swatch/index.ts


;// CONCATENATED MODULE: ../../packages/ui/index.tsx




// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion.mjs + 193 modules
var motion = __webpack_require__(4472);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 5 modules
var AnimatePresence = __webpack_require__(5239);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./pages/index.tsx






const accordionData = [
    {
        id: 1,
        header: "Show Your Value Proposition",
        description: "Our intuitive package builder lets customers define their ideal package based on their needs and lets your sales team explain your value propositions."
    },
    {
        id: 2,
        header: "Streamlined Sales Process",
        description: "Simplify closing deals by reducing the number of steps between a product demonstration and the signing giving your sales team more time to focus on building relationships and closing deals."
    },
    {
        id: 3,
        header: "Increase Your Average Basket",
        description: "Through our unique way of presenting your features and/or services, your customers can better perceive your value proposition and thus increase your sales."
    },
    {
        id: 4,
        header: "Sales Enablement",
        description: "Provide your sales with relevant information and improve your sales strategy with our powerful analysis, reporting tools, and recommendations."
    }
];
const Accordion = (param)=>{
    let { i , expanded , setExpanded  } = param;
    const isOpen = i.id === expanded;
    // By using `AnimatePresence` to mount and unmount the contents, we can animate
    // them in and out while also only rendering the contents of open accordions
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
        className: "px-6 py-6 rounded-lg cursor-pointer",
        animate: {
            backgroundColor: isOpen ? "#FFAB05" : "#ffffff"
        },
        onClick: ()=>setExpanded(i.id),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.header */.E.header, {
                className: "text-lg font-articulat font-bold mb-3 relative pr-[30px]",
                initial: false,
                children: [
                    i.header,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        initial: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            animate: {
                                rotate: isOpen ? 180 : 0,
                                transition: {
                                    duration: 0.3,
                                    ease: "easeIn"
                                }
                            },
                            className: "absolute top-0 right-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/home/arrow.svg",
                                alt: "Billy",
                                width: 28,
                                height: 28
                            })
                        }, "arrow")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.section */.E.section, {
                    className: "relative overflow-hidden font-articulat text-sm",
                    initial: "collapsed",
                    animate: "open",
                    exit: "collapsed",
                    variants: {
                        open: {
                            opacity: 1,
                            height: "auto"
                        },
                        collapsed: {
                            opacity: 0,
                            height: 0
                        }
                    },
                    children: i.description
                }, "content")
            })
        ]
    });
};
function Index() {
    const [carouselWith, setCarouselWidth] = (0,react.useState)(0);
    const carousel = (0,react.useRef)({
        scrollWidth: 0,
        offsetWidth: 0
    });
    const [expanded, setExpanded] = (0,react.useState)(1);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        setCarouselWidth((carousel === null || carousel === void 0 ? void 0 : (ref = carousel.current) === null || ref === void 0 ? void 0 : ref.scrollWidth) - (carousel === null || carousel === void 0 ? void 0 : (ref1 = carousel.current) === null || ref1 === void 0 ? void 0 : ref1.offsetWidth));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Billy - Modern CPQ for SaaS"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://www.billycpq.com/api/og"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Empower your sales team to Close Deals Faster and Boost Your Average Basket. CPQ (Configure, Price & Quote) designed for SaaS Companies."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/apple-touch-icon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/favicon-32x32.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/favicon-16x16.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "mask-icon",
                        href: "/safari-pinned-tab.svg",
                        color: "#5bbad5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#da532c"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#ffffff"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-hero-pattern bg-[center_top] bg-repeat-x",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                        className: "py-5 absolute left-0 right-0 top-0 w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-[1230px] w-full m-auto px-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "logo.svg",
                                        alt: "Billy",
                                        width: 133,
                                        height: 38
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button, {
                                        href: "https://tally.so/r/mDBjaN",
                                        target: "_blank",
                                        rel: "nofollow",
                                        children: "Request Demo"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "md:pt-[145px] pb-[40px] md:pb-[170px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-[1230px] w-full m-auto px-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pt-[85px] flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "text-[42px] md:text-[62px] leading-none mb-6 font-cerebri",
                                                children: "Make the sales process smarter."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-6 font-articulat",
                                                children: "Billy is the modern version of CPQ (Configure, Price & Quote) designed for SaaS Companies. It helps you to empower your sales team to close deals faster, speed up your quoting process and increase your average basket."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button, {
                                                href: "https://tally.so/r/mDBjaN",
                                                target: "_blank",
                                                rel: "nofollow",
                                                className: "bg-[#FFAB05] hover:bg-[#000000] !text-black hover:!text-white px-10 py-4 !h-auto hidden md:inline-flex",
                                                children: "Request Demo"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-end items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/home/hero-img.webp",
                                            alt: "Billy",
                                            width: 677,
                                            height: 487,
                                            className: "h-auto m-auto"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "pb-[20px] md:pb-[75px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-w-[1230px] w-full m-auto px-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-center text-[30px] md:text-[36px] font-articulat mb-12",
                                    children: "Who is using Billy?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                    ref: carousel,
                                    className: "overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                        drag: "x",
                                        dragConstraints: {
                                            right: 0,
                                            left: -carouselWith
                                        },
                                        className: "flex gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                                className: "min-h-[250px] min-w-[280px] md:min-w-[32%] border b-gray-600 p-5 rounded-3xl flex justify-between flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "min-h-[60px] flex items-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "/home/logo-da.png",
                                                                    alt: "da",
                                                                    width: 46,
                                                                    height: 60,
                                                                    className: "grayscale"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-base font-articulat text-[#696969] my-8",
                                                                children: "Thanks to this tool, we were able to showcase the full value proposition of our SaaS product and increase our average basket size by 23,8%. Our sales team was able to focus on closing deals rather than spending hours on creating quotes. Highly recommended at the start and at the end !"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/home/da-gm.png",
                                                                alt: "da gm",
                                                                width: 50,
                                                                height: 50,
                                                                className: "mb-3"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-black font-articulat font-bold",
                                                                children: "Justin Barthelemy"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-[#696969] font-articulat",
                                                                children: "Country Manager at Doctoranytime"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                                className: "min-h-[250px] min-w-[280px] md:min-w-[32%] border b-gray-600 p-5 rounded-3xl flex justify-between flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "min-h-[60px] flex items-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "/home/logo-raizume.png",
                                                                    alt: "da",
                                                                    width: 96,
                                                                    height: 37,
                                                                    className: "grayscale"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-base font-articulat text-[#696969] my-8",
                                                                children: "As the Head of Sales, I can confidently say that this tool has transformed the way we do business. Our sales team is more efficient, effective and has been able to focus on what they do best - closing deals. Highly recommend giving it a try!"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/home/izysea-gm.png",
                                                                alt: "raizume gm",
                                                                width: 50,
                                                                height: 50,
                                                                className: "mb-3"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-black font-articulat font-bold",
                                                                children: "Luc Garchette"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-[#696969] font-articulat",
                                                                children: "Head of Sales at Raizume"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                                                className: "min-h-[250px] min-w-[280px] md:min-w-[32%] border b-gray-600 p-5 rounded-3xl flex justify-between flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "min-h-[60px] flex items-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "/home/logo-tipaw.png",
                                                                    alt: "da",
                                                                    width: 95,
                                                                    height: 36,
                                                                    className: "grayscale"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-base font-articulat text-[#696969] my-8",
                                                                children: "If you're looking for a way to simplify quote creation and improve your sales results, this tool is a must-have. We were able to streamline our sales process and close deals faster than ever before."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/home/tipaw-gm.png",
                                                                alt: "tipaw gm",
                                                                width: 50,
                                                                height: 50,
                                                                className: "mb-3"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-black font-articulat font-bold",
                                                                children: "Pierre Moens"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-sm text-[#696969] font-articulat",
                                                                children: "CEO at Tipaw"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "py-[40px] md:py-[75px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-[1230px] w-full m-auto px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-center text-[30px] md:text-[36px] font-articulat mb-6",
                            children: "Discover Our Benefits"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[#696969] font-articulat max-w-[1000px] w-full m-auto text-center",
                            children: "We provide an all-in-one solution that streamlines signing, speed up quote creation, and showcases the full value proposition of your software products. Our mission is to help you close deals more efficiently and increase your average basket by empowering your sales team with a modern, customizable, and qualitative closing journey."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-16 flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "max-w-[380px]",
                                    children: accordionData.map((i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
                                            i: i,
                                            expanded: expanded,
                                            setExpanded: setExpanded
                                        }, i.id))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1 hidden md:block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "aspect-[16/9] relative",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                            mode: "wait",
                                            children: accordionData.map((i)=>{
                                                return expanded === i.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                                    className: "absolute top-0 left-0 right-0 bottom-0 m-auto",
                                                    initial: "collapsed",
                                                    animate: "open",
                                                    exit: "collapsed",
                                                    variants: {
                                                        open: {
                                                            y: 0,
                                                            opacity: 1
                                                        },
                                                        collapsed: {
                                                            y: -10,
                                                            opacity: 0
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/home/accordion-".concat(i.id, ".webp"),
                                                        alt: "feature 1",
                                                        width: 678,
                                                        height: 421,
                                                        className: "m-auto"
                                                    })
                                                }, i.id);
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "py-[75px] bg-[#EAEDEF]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-[1230px] w-full m-auto px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-center text-[30px] md:text-[36px] font-articulat mb-6",
                            children: "How should you use it"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid gap-4 md:grid-cols-3 text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[60px] h-[60px] bg-[#FFAB05] m-auto mb-5 rounded-full flex items-center justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/home/number-1.svg",
                                                alt: "1",
                                                width: 15,
                                                height: 25
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-[22px] font-articulat mb-5",
                                            children: "Define your Features"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "font-articulat text-[#696969]",
                                            children: "List up all your different features, options add-ons and packages so you can easily show your value proposition !"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[60px] h-[60px] bg-[#FFAB05] m-auto mb-5 rounded-full flex items-center justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/home/number-2.svg",
                                                alt: "1",
                                                width: 20,
                                                height: 25
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-[22px] font-articulat mb-5",
                                            children: "Create your Components and Plans"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "font-articulat text-[#696969]",
                                            children: "Generate the components and plans that will emphasize the power of your service."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[60px] h-[60px] bg-[#FFAB05] m-auto mb-5 rounded-full flex items-center justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/home/number-3.svg",
                                                alt: "1",
                                                width: 16,
                                                height: 23
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-[22px] font-articulat mb-5",
                                            children: "Close your Deals"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "font-articulat text-[#696969]",
                                            children: "Create your pages, connect them with your CRM and let your sales team do the magic!"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "py-[75px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-[1230px] w-full m-auto px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-center text-[30px] md:text-[36px] font-articulat mb-6",
                            children: "Integrates Seamlessly With Your Tech Stack"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[#696969] font-articulat max-w-[1000px] w-full m-auto text-center",
                            children: "At Billy, we believe in a new approach to selling SaaS solutions. Our cutting-edge platform offers a modernized CPQ experience that caters to the needs of SaaS companies. By understanding your needs and offering a custom solution integrated with your favorite tools, we help sales teams achieve better results and redefine the sales process."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-wrap md:grid md:gap-4 md:grid-cols-5 text-center mt-20 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-1/2 mb-8 md:w-auto md:mb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/home/hubspot.svg",
                                        alt: "1",
                                        width: 120,
                                        height: 30,
                                        className: "mx-auto"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-1/2 mb-8 md:w-auto md:mb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/home/asana.svg",
                                        alt: "1",
                                        width: 112,
                                        height: 22,
                                        className: "mx-auto"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-1/2 mb-8 md:w-auto md:mb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/home/google.svg",
                                        alt: "1",
                                        width: 106,
                                        height: 34,
                                        className: "mx-auto"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-1/2 mb-8 md:w-auto md:mb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/home/slack.svg",
                                        alt: "1",
                                        width: 112,
                                        height: 29,
                                        className: "mx-auto"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full mb-8 md:w-auto md:mb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/home/stripe.svg",
                                        alt: "1",
                                        width: 86,
                                        height: 36,
                                        className: "mx-auto"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "py-[40px] md:py-[75px] bg-[#FFAB05] text-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-[1230px] w-full m-auto px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-center text-[30px] md:text-[36px] font-articulat mb-6",
                            children: "Join the Revolution"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-white font-articulat max-w-[940px] w-full m-auto text-center",
                            children: "Ready to take your sales process to the next level? Try Billy for free today and discover how our modern CPQ platform can help you revolutionize your SaaS sales strategy. Empower your sales team, increase your average basket, and transform the way you sell with Billy."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center mt-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button, {
                                href: "https://tally.so/r/mDBjaN",
                                target: "_blank",
                                rel: "nofollow",
                                className: "text-lg md:px-6 py-2 !h-auto rounded-full",
                                children: "Request demo"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: "py-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-[1230px] w-full m-auto px-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "logo.svg",
                            alt: "Billy",
                            width: 133,
                            height: 38
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: "py-4 border-t border-[#C9D3DD]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-[1230px] w-full m-auto px-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs",
                        children: "billycpq. All right reserved. \xa9 2023"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var pages = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [566,774,888,179], function() { return __webpack_exec__(7314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);